/**
 * @file html5.js
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 */

'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used. \n            This may prevent text tracks from loading.'], ['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used. \n            This may prevent text tracks from loading.']);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var _techJs = require('./tech.js');

var _techJs2 = _interopRequireDefault(_techJs);

var _component = require('../component');

var _component2 = _interopRequireDefault(_component);

var _utilsDomJs = require('../utils/dom.js');

var Dom = _interopRequireWildcard(_utilsDomJs);

var _utilsUrlJs = require('../utils/url.js');

var Url = _interopRequireWildcard(_utilsUrlJs);

var _utilsFnJs = require('../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _utilsLogJs = require('../utils/log.js');

var _utilsLogJs2 = _interopRequireDefault(_utilsLogJs);

var _tsml = require('tsml');

var _tsml2 = _interopRequireDefault(_tsml);

var _srcJsTracksTextTrackJs = require('../../../src/js/tracks/text-track.js');

var _srcJsTracksTextTrackJs2 = _interopRequireDefault(_srcJsTracksTextTrackJs);

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

var _globalWindow = require('global/window');

var _globalWindow2 = _interopRequireDefault(_globalWindow);

var _objectAssign = require('object.assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utilsMergeOptionsJs = require('../utils/merge-options.js');

var _utilsMergeOptionsJs2 = _interopRequireDefault(_utilsMergeOptionsJs);

var _utilsToTitleCaseJs = require('../utils/to-title-case.js');

var _utilsToTitleCaseJs2 = _interopRequireDefault(_utilsToTitleCaseJs);

/**
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 *
 * @param {Object=} options Object of option names and values
 * @param {Function=} ready Ready callback function
 * @extends Tech
 * @class Html5
 */

var Html5 = (function (_Tech) {
  _inherits(Html5, _Tech);

  function Html5(options, ready) {
    var _this = this;

    _classCallCheck(this, Html5);

    _Tech.call(this, options, ready);

    var source = options.source;
    var crossoriginTracks = false;

    // Set the source if one is provided
    // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
    // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
    // anyway so the error gets fired.
    if (source && (this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
      this.setSource(source);
    } else {
      this.handleLateInit_(this.el_);
    }

    if (this.el_.hasChildNodes()) {

      var nodes = this.el_.childNodes;
      var nodesLength = nodes.length;
      var removeNodes = [];

      while (nodesLength--) {
        var node = nodes[nodesLength];
        var nodeName = node.nodeName.toLowerCase();

        if (nodeName === 'track') {
          if (!this.featuresNativeTextTracks) {
            // Empty video tag tracks so the built-in player doesn't use them also.
            // This may not be fast enough to stop HTML5 browsers from reading the tags
            // so we'll need to turn off any default tracks if we're manually doing
            // captions and subtitles. videoElement.textTracks
            removeNodes.push(node);
          } else {
            // store HTMLTrackElement and TextTrack to remote list
            this.remoteTextTrackEls().addTrackElement_(node);
            this.remoteTextTracks().addTrack_(node.track);
            if (!crossoriginTracks && !this.el_.hasAttribute('crossorigin') && Url.isCrossOrigin(node.src)) {
              crossoriginTracks = true;
            }
          }
        }
      }

      for (var i = 0; i < removeNodes.length; i++) {
        this.el_.removeChild(removeNodes[i]);
      }
    }

    var trackTypes = ['audio', 'video'];

    // ProxyNativeTextTracks
    trackTypes.forEach(function (type) {
      var capitalType = _utilsToTitleCaseJs2['default'](type);

      if (!_this['featuresNative' + capitalType + 'Tracks']) {
        return;
      }
      var tl = _this.el()[type + 'Tracks'];

      if (tl && tl.addEventListener) {
        tl.addEventListener('change', Fn.bind(_this, _this['handle' + capitalType + 'TrackChange_']));
        tl.addEventListener('addtrack', Fn.bind(_this, _this['handle' + capitalType + 'TrackAdd_']));
        tl.addEventListener('removetrack', Fn.bind(_this, _this['handle' + capitalType + 'TrackRemove_']));
      }
    });

    if (this.featuresNativeTextTracks) {
      if (crossoriginTracks) {
        _utilsLogJs2['default'].warn(_tsml2['default'](_templateObject));
      }

      this.handleTextTrackChange_ = Fn.bind(this, this.handleTextTrackChange);
      this.handleTextTrackAdd_ = Fn.bind(this, this.handleTextTrackAdd);
      this.handleTextTrackRemove_ = Fn.bind(this, this.handleTextTrackRemove);
      this.proxyNativeTextTracks_();
    }

    // Determine if native controls should be used
    // Our goal should be to get the custom controls on mobile solid everywhere
    // so we can remove this all together. Right now this will block custom
    // controls on touch enabled laptops like the Chrome Pixel
    if (browser.TOUCH_ENABLED && options.nativeControlsForTouch === true || browser.IS_IPHONE || browser.IS_NATIVE_ANDROID) {
      this.setControls(true);
    }

    this.triggerReady();
  }

  /* HTML5 Support Testing ---------------------------------------------------- */

  /*
  * Element for testing browser HTML5 video capabilities
  *
  * @type {Element}
  * @constant
  * @private
  */

  /**
   * Dispose of html5 media element
   *
   * @method dispose
   */

  Html5.prototype.dispose = function dispose() {
    var _this2 = this;

    // Un-ProxyNativeTracks
    ['audio', 'video', 'text'].forEach(function (type) {
      var capitalType = _utilsToTitleCaseJs2['default'](type);
      var tl = _this2.el_[type + 'Tracks'];

      if (tl && tl.removeEventListener) {
        tl.removeEventListener('change', _this2['handle' + capitalType + 'TrackChange_']);
        tl.removeEventListener('addtrack', _this2['handle' + capitalType + 'TrackAdd_']);
        tl.removeEventListener('removetrack', _this2['handle' + capitalType + 'TrackRemove_']);
      }
    });

    Html5.disposeMediaElement(this.el_);
    // tech will handle clearing of the emulated track list
    _Tech.prototype.dispose.call(this);
  };

  /**
   * Create the component's DOM element
   *
   * @return {Element}
   * @method createEl
   */

  Html5.prototype.createEl = function createEl() {
    var el = this.options_.tag;

    // Check if this browser supports moving the element into the box.
    // On the iPhone video will break if you move the element,
    // So we have to create a brand new element.
    if (!el || this['movingMediaElementInDOM'] === false) {

      // If the original tag is still there, clone and remove it.
      if (el) {
        var clone = el.cloneNode(true);
        el.parentNode.insertBefore(clone, el);
        Html5.disposeMediaElement(el);
        el = clone;
      } else {
        el = _globalDocument2['default'].createElement('video');

        // determine if native controls should be used
        var tagAttributes = this.options_.tag && Dom.getElAttributes(this.options_.tag);
        var attributes = _utilsMergeOptionsJs2['default']({}, tagAttributes);
        if (!browser.TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
          delete attributes.controls;
        }

        Dom.setElAttributes(el, _objectAssign2['default'](attributes, {
          id: this.options_.techId,
          'class': 'vjs-tech'
        }));
      }
    }

    // Update specific tag settings, in case they were overridden
    var settingsAttrs = ['autoplay', 'preload', 'loop', 'muted'];
    for (var i = settingsAttrs.length - 1; i >= 0; i--) {
      var attr = settingsAttrs[i];
      var overwriteAttrs = {};
      if (typeof this.options_[attr] !== 'undefined') {
        overwriteAttrs[attr] = this.options_[attr];
      }
      Dom.setElAttributes(el, overwriteAttrs);
    }

    return el;
    // jenniisawesome = true;
  };

  // If we're loading the playback object after it has started loading
  // or playing the video (often with autoplay on) then the loadstart event
  // has already fired and we need to fire it manually because many things
  // rely on it.

  Html5.prototype.handleLateInit_ = function handleLateInit_(el) {
    var _this3 = this;

    if (el.networkState === 0 || el.networkState === 3) {
      // The video element hasn't started loading the source yet
      // or didn't find a source
      return;
    }

    if (el.readyState === 0) {
      var _ret = (function () {
        // NetworkState is set synchronously BUT loadstart is fired at the
        // end of the current stack, usually before setInterval(fn, 0).
        // So at this point we know loadstart may have already fired or is
        // about to fire, and either way the player hasn't seen it yet.
        // We don't want to fire loadstart prematurely here and cause a
        // double loadstart so we'll wait and see if it happens between now
        // and the next loop, and fire it if not.
        // HOWEVER, we also want to make sure it fires before loadedmetadata
        // which could also happen between now and the next loop, so we'll
        // watch for that also.
        var loadstartFired = false;
        var setLoadstartFired = function setLoadstartFired() {
          loadstartFired = true;
        };
        _this3.on('loadstart', setLoadstartFired);

        var triggerLoadstart = function triggerLoadstart() {
          // We did miss the original loadstart. Make sure the player
          // sees loadstart before loadedmetadata
          if (!loadstartFired) {
            this.trigger('loadstart');
          }
        };
        _this3.on('loadedmetadata', triggerLoadstart);

        _this3.ready(function () {
          this.off('loadstart', setLoadstartFired);
          this.off('loadedmetadata', triggerLoadstart);

          if (!loadstartFired) {
            // We did miss the original native loadstart. Fire it now.
            this.trigger('loadstart');
          }
        });

        return {
          v: undefined
        };
      })();

      if (typeof _ret === 'object') return _ret.v;
    }

    // From here on we know that loadstart already fired and we missed it.
    // The other readyState events aren't as much of a problem if we double
    // them, so not going to go to as much trouble as loadstart to prevent
    // that unless we find reason to.
    var eventsToTrigger = ['loadstart'];

    // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
    eventsToTrigger.push('loadedmetadata');

    // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
    if (el.readyState >= 2) {
      eventsToTrigger.push('loadeddata');
    }

    // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
    if (el.readyState >= 3) {
      eventsToTrigger.push('canplay');
    }

    // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
    if (el.readyState >= 4) {
      eventsToTrigger.push('canplaythrough');
    }

    // We still need to give the player time to add event listeners
    this.ready(function () {
      eventsToTrigger.forEach(function (type) {
        this.trigger(type);
      }, this);
    });
  };

  Html5.prototype.proxyNativeTextTracks_ = function proxyNativeTextTracks_() {
    var tt = this.el().textTracks;

    if (tt) {
      // Add tracks - if player is initialised after DOM loaded, textTracks
      // will not trigger addtrack
      for (var i = 0; i < tt.length; i++) {
        this.textTracks().addTrack_(tt[i]);
      }

      if (tt.addEventListener) {
        tt.addEventListener('change', this.handleTextTrackChange_);
        tt.addEventListener('addtrack', this.handleTextTrackAdd_);
        tt.addEventListener('removetrack', this.handleTextTrackRemove_);
      }
    }
  };

  Html5.prototype.handleTextTrackChange = function handleTextTrackChange(e) {
    var tt = this.textTracks();
    this.textTracks().trigger({
      type: 'change',
      target: tt,
      currentTarget: tt,
      srcElement: tt
    });
  };

  Html5.prototype.handleTextTrackAdd = function handleTextTrackAdd(e) {
    this.textTracks().addTrack_(e.track);
  };

  Html5.prototype.handleTextTrackRemove = function handleTextTrackRemove(e) {
    this.textTracks().removeTrack_(e.track);
  };

  Html5.prototype.handleVideoTrackChange_ = function handleVideoTrackChange_(e) {
    var vt = this.videoTracks();
    this.videoTracks().trigger({
      type: 'change',
      target: vt,
      currentTarget: vt,
      srcElement: vt
    });
  };

  Html5.prototype.handleVideoTrackAdd_ = function handleVideoTrackAdd_(e) {
    this.videoTracks().addTrack_(e.track);
  };

  Html5.prototype.handleVideoTrackRemove_ = function handleVideoTrackRemove_(e) {
    this.videoTracks().removeTrack_(e.track);
  };

  Html5.prototype.handleAudioTrackChange_ = function handleAudioTrackChange_(e) {
    var audioTrackList = this.audioTracks();
    this.audioTracks().trigger({
      type: 'change',
      target: audioTrackList,
      currentTarget: audioTrackList,
      srcElement: audioTrackList
    });
  };

  Html5.prototype.handleAudioTrackAdd_ = function handleAudioTrackAdd_(e) {
    this.audioTracks().addTrack_(e.track);
  };

  Html5.prototype.handleAudioTrackRemove_ = function handleAudioTrackRemove_(e) {
    this.audioTracks().removeTrack_(e.track);
  };

  /**
   * Play for html5 tech
   *
   * @method play
   */

  Html5.prototype.play = function play() {
    var promise = this.el_.play();
    if (promise) // suppress uncaught DOMException
      promise['catch'](function () {});
  };

  /**
   * Pause for html5 tech
   *
   * @method pause
   */

  Html5.prototype.pause = function pause() {
    this.el_.pause();
  };

  /**
   * Paused for html5 tech
   *
   * @return {Boolean}
   * @method paused
   */

  Html5.prototype.paused = function paused() {
    return this.el_.paused;
  };

  /**
   * Get current time
   *
   * @return {Number}
   * @method currentTime
   */

  Html5.prototype.currentTime = function currentTime() {
    return this.el_.currentTime;
  };

  /**
   * Set current time
   *
   * @param {Number} seconds Current time of video
   * @method setCurrentTime
   */

  Html5.prototype.setCurrentTime = function setCurrentTime(seconds) {
    try {
      this.el_.currentTime = seconds;
    } catch (e) {
      _utilsLogJs2['default'](e, 'Video is not ready. (Video.js)');
      // this.warning(VideoJS.warnings.videoNotReady);
    }
  };

  /**
   * Get duration
   *
   * @return {Number}
   * @method duration
   */

  Html5.prototype.duration = function duration() {
    return this.el_.duration || 0;
  };

  /**
   * Get a TimeRange object that represents the intersection
   * of the time ranges for which the user agent has all
   * relevant media
   *
   * @return {TimeRangeObject}
   * @method buffered
   */

  Html5.prototype.buffered = function buffered() {
    return this.el_.buffered;
  };

  /**
   * Get volume level
   *
   * @return {Number}
   * @method volume
   */

  Html5.prototype.volume = function volume() {
    return this.el_.volume;
  };

  /**
   * Set volume level
   *
   * @param {Number} percentAsDecimal Volume percent as a decimal
   * @method setVolume
   */

  Html5.prototype.setVolume = function setVolume(percentAsDecimal) {
    this.el_.volume = percentAsDecimal;
  };

  /**
   * Get if muted
   *
   * @return {Boolean}
   * @method muted
   */

  Html5.prototype.muted = function muted() {
    return this.el_.muted;
  };

  /**
   * Set muted
   *
   * @param {Boolean} If player is to be muted or note
   * @method setMuted
   */

  Html5.prototype.setMuted = function setMuted(muted) {
    this.el_.muted = muted;
  };

  /**
   * Get player width
   *
   * @return {Number}
   * @method width
   */

  Html5.prototype.width = function width() {
    return this.el_.offsetWidth;
  };

  /**
   * Get player height
   *
   * @return {Number}
   * @method height
   */

  Html5.prototype.height = function height() {
    return this.el_.offsetHeight;
  };

  /**
   * Get if there is fullscreen support
   *
   * @return {Boolean}
   * @method supportsFullScreen
   */

  Html5.prototype.supportsFullScreen = function supportsFullScreen() {
    if (typeof this.el_.webkitEnterFullScreen === 'function') {
      var userAgent = _globalWindow2['default'].navigator.userAgent;
      // Seems to be broken in Chromium/Chrome && Safari in Leopard
      if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
        return true;
      }
    }
    return false;
  };

  /**
   * Request to enter fullscreen
   *
   * @method enterFullScreen
   */

  Html5.prototype.enterFullScreen = function enterFullScreen() {
    var video = this.el_;

    if ('webkitDisplayingFullscreen' in video) {
      this.one('webkitbeginfullscreen', function () {
        this.one('webkitendfullscreen', function () {
          this.trigger('fullscreenchange', { isFullscreen: false });
        });

        this.trigger('fullscreenchange', { isFullscreen: true });
      });
    }

    if (video.paused && video.networkState <= video.HAVE_METADATA) {
      // attempt to prime the video element for programmatic access
      // this isn't necessary on the desktop but shouldn't hurt
      this.play();

      // playing and pausing synchronously during the transition to fullscreen
      // can get iOS ~6.1 devices into a play/pause loop
      this.setTimeout(function () {
        video.pause();
        video.webkitEnterFullScreen();
      }, 0);
    } else {
      video.webkitEnterFullScreen();
    }
  };

  /**
   * Request to exit fullscreen
   *
   * @method exitFullScreen
   */

  Html5.prototype.exitFullScreen = function exitFullScreen() {
    this.el_.webkitExitFullScreen();
  };

  /**
   * Get/set video
   *
   * @param {Object=} src Source object
   * @return {Object}
   * @method src
   */

  Html5.prototype.src = function src(_src) {
    if (_src === undefined) {
      return this.el_.src;
    } else {
      // Setting src through `src` instead of `setSrc` will be deprecated
      this.setSrc(_src);
    }
  };

  /**
   * Set video
   *
   * @param {Object} src Source object
   * @deprecated
   * @method setSrc
   */

  Html5.prototype.setSrc = function setSrc(src) {
    this.el_.src = src;
  };

  /**
   * Load media into player
   *
   * @method load
   */

  Html5.prototype.load = function load() {
    this.el_.load();
  };

  /**
   * Reset the tech. Removes all sources and calls `load`.
   *
   * @method reset
   */

  Html5.prototype.reset = function reset() {
    Html5.resetMediaElement(this.el_);
  };

  /**
   * Get current source
   *
   * @return {Object}
   * @method currentSrc
   */

  Html5.prototype.currentSrc = function currentSrc() {
    if (this.currentSource_) {
      return this.currentSource_.src;
    } else {
      return this.el_.currentSrc;
    }
  };

  /**
   * Get poster
   *
   * @return {String}
   * @method poster
   */

  Html5.prototype.poster = function poster() {
    return this.el_.poster;
  };

  /**
   * Set poster
   *
   * @param {String} val URL to poster image
   * @method
   */

  Html5.prototype.setPoster = function setPoster(val) {
    this.el_.poster = val;
  };

  /**
   * Get preload attribute
   *
   * @return {String}
   * @method preload
   */

  Html5.prototype.preload = function preload() {
    return this.el_.preload;
  };

  /**
   * Set preload attribute
   *
   * @param {String} val Value for preload attribute
   * @method setPreload
   */

  Html5.prototype.setPreload = function setPreload(val) {
    this.el_.preload = val;
  };

  /**
   * Get autoplay attribute
   *
   * @return {String}
   * @method autoplay
   */

  Html5.prototype.autoplay = function autoplay() {
    return this.el_.autoplay;
  };

  /**
   * Set autoplay attribute
   *
   * @param {String} val Value for preload attribute
   * @method setAutoplay
   */

  Html5.prototype.setAutoplay = function setAutoplay(val) {
    this.el_.autoplay = val;
  };

  /**
   * Get controls attribute
   *
   * @return {String}
   * @method controls
   */

  Html5.prototype.controls = function controls() {
    return this.el_.controls;
  };

  /**
   * Set controls attribute
   *
   * @param {String} val Value for controls attribute
   * @method setControls
   */

  Html5.prototype.setControls = function setControls(val) {
    this.el_.controls = !!val;
  };

  /**
   * Get loop attribute
   *
   * @return {String}
   * @method loop
   */

  Html5.prototype.loop = function loop() {
    return this.el_.loop;
  };

  /**
   * Set loop attribute
   *
   * @param {String} val Value for loop attribute
   * @method setLoop
   */

  Html5.prototype.setLoop = function setLoop(val) {
    this.el_.loop = val;
  };

  /**
   * Get error value
   *
   * @return {String}
   * @method error
   */

  Html5.prototype.error = function error() {
    return this.el_.error;
  };

  /**
   * Get whether or not the player is in the "seeking" state
   *
   * @return {Boolean}
   * @method seeking
   */

  Html5.prototype.seeking = function seeking() {
    return this.el_.seeking;
  };

  /**
   * Get a TimeRanges object that represents the
   * ranges of the media resource to which it is possible
   * for the user agent to seek.
   *
   * @return {TimeRangeObject}
   * @method seekable
   */

  Html5.prototype.seekable = function seekable() {
    return this.el_.seekable;
  };

  /**
   * Get if video ended
   *
   * @return {Boolean}
   * @method ended
   */

  Html5.prototype.ended = function ended() {
    return this.el_.ended;
  };

  /**
   * Get the value of the muted content attribute
   * This attribute has no dynamic effect, it only
   * controls the default state of the element
   *
   * @return {Boolean}
   * @method defaultMuted
   */

  Html5.prototype.defaultMuted = function defaultMuted() {
    return this.el_.defaultMuted;
  };

  /**
   * Get desired speed at which the media resource is to play
   *
   * @return {Number}
   * @method playbackRate
   */

  Html5.prototype.playbackRate = function playbackRate() {
    return this.el_.playbackRate;
  };

  /**
   * Returns a TimeRanges object that represents the ranges of the
   * media resource that the user agent has played.
   * @return {TimeRangeObject} the range of points on the media
   * timeline that has been reached through normal playback
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-played
   */

  Html5.prototype.played = function played() {
    return this.el_.played;
  };

  /**
   * Set desired speed at which the media resource is to play
   *
   * @param {Number} val Speed at which the media resource is to play
   * @method setPlaybackRate
   */

  Html5.prototype.setPlaybackRate = function setPlaybackRate(val) {
    this.el_.playbackRate = val;
  };

  /**
   * Get the current state of network activity for the element, from
   * the list below
   * NETWORK_EMPTY (numeric value 0)
   * NETWORK_IDLE (numeric value 1)
   * NETWORK_LOADING (numeric value 2)
   * NETWORK_NO_SOURCE (numeric value 3)
   *
   * @return {Number}
   * @method networkState
   */

  Html5.prototype.networkState = function networkState() {
    return this.el_.networkState;
  };

  /**
   * Get a value that expresses the current state of the element
   * with respect to rendering the current playback position, from
   * the codes in the list below
   * HAVE_NOTHING (numeric value 0)
   * HAVE_METADATA (numeric value 1)
   * HAVE_CURRENT_DATA (numeric value 2)
   * HAVE_FUTURE_DATA (numeric value 3)
   * HAVE_ENOUGH_DATA (numeric value 4)
   *
   * @return {Number}
   * @method readyState
   */

  Html5.prototype.readyState = function readyState() {
    return this.el_.readyState;
  };

  /**
   * Get width of video
   *
   * @return {Number}
   * @method videoWidth
   */

  Html5.prototype.videoWidth = function videoWidth() {
    return this.el_.videoWidth;
  };

  /**
   * Get height of video
   *
   * @return {Number}
   * @method videoHeight
   */

  Html5.prototype.videoHeight = function videoHeight() {
    return this.el_.videoHeight;
  };

  /**
   * Get text tracks
   *
   * @return {TextTrackList}
   * @method textTracks
   */

  Html5.prototype.textTracks = function textTracks() {
    return _Tech.prototype.textTracks.call(this);
  };

  /**
   * Creates and returns a text track object
   *
   * @param {String} kind Text track kind (subtitles, captions, descriptions
   *                                       chapters and metadata)
   * @param {String=} label Label to identify the text track
   * @param {String=} language Two letter language abbreviation
   * @return {TextTrackObject}
   * @method addTextTrack
   */

  Html5.prototype.addTextTrack = function addTextTrack(kind, label, language) {
    if (!this['featuresNativeTextTracks']) {
      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
    }

    return this.el_.addTextTrack(kind, label, language);
  };

  /**
   * Creates a remote text track object and returns a html track element
   *
   * @param {Object} options The object should contain values for
   * kind, language, label and src (location of the WebVTT file)
   * @return {HTMLTrackElement}
   * @method addRemoteTextTrack
   */

  Html5.prototype.addRemoteTextTrack = function addRemoteTextTrack() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    if (!this['featuresNativeTextTracks']) {
      return _Tech.prototype.addRemoteTextTrack.call(this, options);
    }

    var htmlTrackElement = _globalDocument2['default'].createElement('track');

    if (options.kind) {
      htmlTrackElement.kind = options.kind;
    }
    if (options.label) {
      htmlTrackElement.label = options.label;
    }
    if (options.language || options.srclang) {
      htmlTrackElement.srclang = options.language || options.srclang;
    }
    if (options['default']) {
      htmlTrackElement['default'] = options['default'];
    }
    if (options.id) {
      htmlTrackElement.id = options.id;
    }
    if (options.src) {
      htmlTrackElement.src = options.src;
    }

    this.el().appendChild(htmlTrackElement);

    // store HTMLTrackElement and TextTrack to remote list
    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
    this.remoteTextTracks().addTrack_(htmlTrackElement.track);

    return htmlTrackElement;
  };

  /**
   * Remove remote text track from TextTrackList object
   *
   * @param {TextTrackObject} track Texttrack object to remove
   * @method removeRemoteTextTrack
   */

  Html5.prototype.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
    if (!this['featuresNativeTextTracks']) {
      return _Tech.prototype.removeRemoteTextTrack.call(this, track);
    }

    var tracks = undefined,
        i = undefined;

    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);

    // remove HTMLTrackElement and TextTrack from remote list
    this.remoteTextTrackEls().removeTrackElement_(trackElement);
    this.remoteTextTracks().removeTrack_(track);

    tracks = this.$$('track');

    i = tracks.length;
    while (i--) {
      if (track === tracks[i] || track === tracks[i].track) {
        this.el().removeChild(tracks[i]);
      }
    }
  };

  return Html5;
})(_techJs2['default']);

Html5.TEST_VID = _globalDocument2['default'].createElement('video');
var track = _globalDocument2['default'].createElement('track');
track.kind = 'captions';
track.srclang = 'en';
track.label = 'English';
Html5.TEST_VID.appendChild(track);

/*
 * Check if HTML5 video is supported by this browser/device
 *
 * @return {Boolean}
 */
Html5.isSupported = function () {
  // IE9 with no Media Player is a LIAR! (#984)
  try {
    Html5.TEST_VID['volume'] = 0.5;
  } catch (e) {
    return false;
  }

  return !!Html5.TEST_VID.canPlayType;
};

// Add Source Handler pattern functions to this tech
_techJs2['default'].withSourceHandlers(Html5);

/*
 * The default native source handler.
 * This simply passes the source to the video element. Nothing fancy.
 *
 * @param  {Object} source   The source object
 * @param  {Html5} tech  The instance of the HTML5 tech
 */
Html5.nativeSourceHandler = {};

/*
 * Check if the video element can play the given videotype
 *
 * @param  {String} type    The mimetype to check
 * @return {String}         'probably', 'maybe', or '' (empty string)
 */
Html5.nativeSourceHandler.canPlayType = function (type) {
  // IE9 on Windows 7 without MediaPlayer throws an error here
  // https://github.com/videojs/video.js/issues/519
  try {
    return Html5.TEST_VID.canPlayType(type);
  } catch (e) {
    return '';
  }
};

/*
 * Check if the video element can handle the source natively
 *
 * @param  {Object} source  The source object
 * @return {String}         'probably', 'maybe', or '' (empty string)
 */
Html5.nativeSourceHandler.canHandleSource = function (source) {
  var match, ext;

  // If a type was provided we should rely on that
  if (source.type) {
    return Html5.nativeSourceHandler.canPlayType(source.type);
  } else if (source.src) {
    // If no type, fall back to checking 'video/[EXTENSION]'
    ext = Url.getFileExtension(source.src);

    return Html5.nativeSourceHandler.canPlayType('video/' + ext);
  }

  return '';
};

/*
 * Pass the source to the video element
 * Adaptive source handlers will have more complicated workflows before passing
 * video data to the video element
 *
 * @param  {Object} source   The source object
 * @param  {Html5}  tech     The instance of the Html5 tech
 * @param  {Object} options  The options to pass to the source
 */
Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
  tech.setSrc(source.src);
};

/*
* Clean up the source handler when disposing the player or switching sources..
* (no cleanup is needed when supporting the format natively)
*/
Html5.nativeSourceHandler.dispose = function () {};

// Register the native source handler
Html5.registerSourceHandler(Html5.nativeSourceHandler);

/*
 * Check if the volume can be changed in this browser/device.
 * Volume cannot be changed in a lot of mobile devices.
 * Specifically, it can't be changed from 1 on iOS.
 *
 * @return {Boolean}
 */
Html5.canControlVolume = function () {
  var volume = Html5.TEST_VID.volume;
  Html5.TEST_VID.volume = volume / 2 + 0.1;
  return volume !== Html5.TEST_VID.volume;
};

/*
 * Check if playbackRate is supported in this browser/device.
 *
 * @return {Boolean}
 */
Html5.canControlPlaybackRate = function () {
  // Playback rate API is implemented in Android Chrome, but doesn't do anything
  // https://github.com/videojs/video.js/issues/3180
  if (browser.IS_ANDROID && browser.IS_CHROME) {
    return false;
  }
  var playbackRate = Html5.TEST_VID.playbackRate;
  Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
  return playbackRate !== Html5.TEST_VID.playbackRate;
};

/*
 * Check to see if native text tracks are supported by this browser/device
 *
 * @return {Boolean}
 */
Html5.supportsNativeTextTracks = function () {
  var supportsTextTracks;

  // Figure out native text track support
  // If mode is a number, we cannot change it because it'll disappear from view.
  // Browsers with numeric modes include IE10 and older (<=2013) samsung android models.
  // Firefox isn't playing nice either with modifying the mode
  // TODO: Investigate firefox: https://github.com/videojs/video.js/issues/1862
  supportsTextTracks = !!Html5.TEST_VID.textTracks;
  if (supportsTextTracks && Html5.TEST_VID.textTracks.length > 0) {
    supportsTextTracks = typeof Html5.TEST_VID.textTracks[0]['mode'] !== 'number';
  }
  if (supportsTextTracks && browser.IS_FIREFOX) {
    supportsTextTracks = false;
  }
  if (supportsTextTracks && !('onremovetrack' in Html5.TEST_VID.textTracks)) {
    supportsTextTracks = false;
  }

  return supportsTextTracks;
};

/*
 * Check to see if native video tracks are supported by this browser/device
 *
 * @return {Boolean}
 */
Html5.supportsNativeVideoTracks = function () {
  var supportsVideoTracks = !!Html5.TEST_VID.videoTracks;
  return supportsVideoTracks;
};

/*
 * Check to see if native audio tracks are supported by this browser/device
 *
 * @return {Boolean}
 */
Html5.supportsNativeAudioTracks = function () {
  var supportsAudioTracks = !!Html5.TEST_VID.audioTracks;
  return supportsAudioTracks;
};

/**
 * An array of events available on the Html5 tech.
 *
 * @private
 * @type {Array}
 */
Html5.Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'volumechange'];

/*
 * Set the tech's volume control support status
 *
 * @type {Boolean}
 */
Html5.prototype['featuresVolumeControl'] = Html5.canControlVolume();

/*
 * Set the tech's playbackRate support status
 *
 * @type {Boolean}
 */
Html5.prototype['featuresPlaybackRate'] = Html5.canControlPlaybackRate();

/*
 * Set the tech's status on moving the video element.
 * In iOS, if you move a video element in the DOM, it breaks video playback.
 *
 * @type {Boolean}
 */
Html5.prototype['movingMediaElementInDOM'] = !browser.IS_IOS;

/*
 * Set the the tech's fullscreen resize support status.
 * HTML video is able to automatically resize when going to fullscreen.
 * (No longer appears to be used. Can probably be removed.)
 */
Html5.prototype['featuresFullscreenResize'] = true;

/*
 * Set the tech's progress event support status
 * (this disables the manual progress events of the Tech)
 */
Html5.prototype['featuresProgressEvents'] = true;

/*
 * Sets the tech's status on native text track support
 *
 * @type {Boolean}
 */
Html5.prototype['featuresNativeTextTracks'] = Html5.supportsNativeTextTracks();

/**
 * Sets the tech's status on native text track support
 *
 * @type {Boolean}
 */
Html5.prototype['featuresNativeVideoTracks'] = Html5.supportsNativeVideoTracks();

/**
 * Sets the tech's status on native audio track support
 *
 * @type {Boolean}
 */
Html5.prototype['featuresNativeAudioTracks'] = Html5.supportsNativeAudioTracks();

// HTML5 Feature detection and Device Fixes --------------------------------- //
var canPlayType = undefined;
var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
var mp4RE = /^video\/mp4/i;

Html5.patchCanPlayType = function () {
  // Android 4.0 and above can play HLS to some extent but it reports being unable to do so
  if (browser.ANDROID_VERSION >= 4.0) {
    if (!canPlayType) {
      canPlayType = Html5.TEST_VID.constructor.prototype.canPlayType;
    }

    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
      if (type && mpegurlRE.test(type)) {
        return 'maybe';
      }
      return canPlayType.call(this, type);
    };
  }

  // Override Android 2.2 and less canPlayType method which is broken
  if (browser.IS_OLD_ANDROID) {
    if (!canPlayType) {
      canPlayType = Html5.TEST_VID.constructor.prototype.canPlayType;
    }

    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
      if (type && mp4RE.test(type)) {
        return 'maybe';
      }
      return canPlayType.call(this, type);
    };
  }
};

Html5.unpatchCanPlayType = function () {
  var r = Html5.TEST_VID.constructor.prototype.canPlayType;
  Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
  canPlayType = null;
  return r;
};

// by default, patch the video element
Html5.patchCanPlayType();

Html5.disposeMediaElement = function (el) {
  if (!el) {
    return;
  }

  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }

  // remove any child track or source nodes to prevent their loading
  while (el.hasChildNodes()) {
    el.removeChild(el.firstChild);
  }

  // remove any src reference. not setting `src=''` because that causes a warning
  // in firefox
  el.removeAttribute('src');

  // force the media element to update its loading state by calling load()
  // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
  if (typeof el.load === 'function') {
    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function () {
      try {
        el.load();
      } catch (e) {
        // not supported
      }
    })();
  }
};

Html5.resetMediaElement = function (el) {
  if (!el) {
    return;
  }

  var sources = el.querySelectorAll('source');
  var i = sources.length;
  while (i--) {
    el.removeChild(sources[i]);
  }

  // remove any src reference.
  // not setting `src=''` because that throws an error
  el.removeAttribute('src');

  if (typeof el.load === 'function') {
    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
    (function () {
      try {
        el.load();
      } catch (e) {}
    })();
  }
};

_component2['default'].registerComponent('Html5', Html5);
_techJs2['default'].registerTech('Html5', Html5);
exports['default'] = Html5;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9qcy90ZWNoL2h0bWw1LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztzQkFLaUIsV0FBVzs7Ozt5QkFDTixjQUFjOzs7OzBCQUNmLGlCQUFpQjs7SUFBMUIsR0FBRzs7MEJBQ00saUJBQWlCOztJQUExQixHQUFHOzt5QkFDSyxnQkFBZ0I7O0lBQXhCLEVBQUU7OzBCQUNFLGlCQUFpQjs7OztvQkFDaEIsTUFBTTs7OztzQ0FDRCxzQ0FBc0M7Ozs7OEJBQ25DLHFCQUFxQjs7SUFBbEMsT0FBTzs7OEJBQ0UsaUJBQWlCOzs7OzRCQUNuQixlQUFlOzs7OzRCQUNmLGVBQWU7Ozs7bUNBQ1QsMkJBQTJCOzs7O2tDQUM1QiwyQkFBMkI7Ozs7Ozs7Ozs7Ozs7SUFVN0MsS0FBSztZQUFMLEtBQUs7O0FBRUUsV0FGUCxLQUFLLENBRUcsT0FBTyxFQUFFLEtBQUssRUFBQzs7OzBCQUZ2QixLQUFLOztBQUdQLHFCQUFNLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQzs7QUFFdEIsUUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQztBQUM5QixRQUFJLGlCQUFpQixHQUFHLEtBQUssQ0FBQzs7Ozs7O0FBTTlCLFFBQUksTUFBTSxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsVUFBVSxLQUFLLE1BQU0sQ0FBQyxHQUFHLElBQUssT0FBTyxDQUFDLEdBQUcsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLGlCQUFpQixLQUFLLENBQUMsQ0FBQyxBQUFDLEVBQUU7QUFDMUcsVUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQztLQUN4QixNQUFNO0FBQ0wsVUFBSSxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7S0FDaEM7O0FBRUQsUUFBSSxJQUFJLENBQUMsR0FBRyxDQUFDLGFBQWEsRUFBRSxFQUFFOztBQUU1QixVQUFJLEtBQUssR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQztBQUNoQyxVQUFJLFdBQVcsR0FBRyxLQUFLLENBQUMsTUFBTSxDQUFDO0FBQy9CLFVBQUksV0FBVyxHQUFHLEVBQUUsQ0FBQzs7QUFFckIsYUFBTyxXQUFXLEVBQUUsRUFBRTtBQUNwQixZQUFJLElBQUksR0FBRyxLQUFLLENBQUMsV0FBVyxDQUFDLENBQUM7QUFDOUIsWUFBSSxRQUFRLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxXQUFXLEVBQUUsQ0FBQzs7QUFFM0MsWUFBSSxRQUFRLEtBQUssT0FBTyxFQUFFO0FBQ3hCLGNBQUksQ0FBQyxJQUFJLENBQUMsd0JBQXdCLEVBQUU7Ozs7O0FBS2xDLHVCQUFXLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1dBQ3hCLE1BQU07O0FBRUwsZ0JBQUksQ0FBQyxrQkFBa0IsRUFBRSxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxDQUFDO0FBQ2pELGdCQUFJLENBQUMsZ0JBQWdCLEVBQUUsQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQzlDLGdCQUFJLENBQUMsaUJBQWlCLElBQ2xCLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxZQUFZLENBQUMsYUFBYSxDQUFDLElBQ3JDLEdBQUcsQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFO0FBQy9CLCtCQUFpQixHQUFHLElBQUksQ0FBQzthQUMxQjtXQUNGO1NBQ0Y7T0FDRjs7QUFFRCxXQUFLLElBQUksQ0FBQyxHQUFDLENBQUMsRUFBRSxDQUFDLEdBQUMsV0FBVyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtBQUN2QyxZQUFJLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztPQUN0QztLQUNGOztBQUVELFFBQUksVUFBVSxHQUFHLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDOzs7QUFHcEMsY0FBVSxDQUFDLE9BQU8sQ0FBQyxVQUFDLElBQUksRUFBSztBQUMzQixVQUFJLFdBQVcsR0FBRyxnQ0FBWSxJQUFJLENBQUMsQ0FBQzs7QUFFcEMsVUFBSSxDQUFDLHlCQUFzQixXQUFXLFlBQVMsRUFBRTtBQUMvQyxlQUFPO09BQ1I7QUFDRCxVQUFJLEVBQUUsR0FBRyxNQUFLLEVBQUUsRUFBRSxDQUFJLElBQUksWUFBUyxDQUFDOztBQUVwQyxVQUFJLEVBQUUsSUFBSSxFQUFFLENBQUMsZ0JBQWdCLEVBQUU7QUFDN0IsVUFBRSxDQUFDLGdCQUFnQixDQUFDLFFBQVEsRUFBRSxFQUFFLENBQUMsSUFBSSxRQUFPLGlCQUFjLFdBQVcsa0JBQWUsQ0FBQyxDQUFDLENBQUM7QUFDdkYsVUFBRSxDQUFDLGdCQUFnQixDQUFDLFVBQVUsRUFBRSxFQUFFLENBQUMsSUFBSSxRQUFPLGlCQUFjLFdBQVcsZUFBWSxDQUFDLENBQUMsQ0FBQztBQUN0RixVQUFFLENBQUMsZ0JBQWdCLENBQUMsYUFBYSxFQUFFLEVBQUUsQ0FBQyxJQUFJLFFBQU8saUJBQWMsV0FBVyxrQkFBZSxDQUFDLENBQUMsQ0FBQztPQUM3RjtLQUNGLENBQUMsQ0FBQzs7QUFFSCxRQUFJLElBQUksQ0FBQyx3QkFBd0IsRUFBRTtBQUNqQyxVQUFJLGlCQUFpQixFQUFFO0FBQ3JCLGdDQUFJLElBQUksb0NBQ3dDLENBQUM7T0FDbEQ7O0FBRUQsVUFBSSxDQUFDLHNCQUFzQixHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxxQkFBcUIsQ0FBQyxDQUFDO0FBQ3hFLFVBQUksQ0FBQyxtQkFBbUIsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsa0JBQWtCLENBQUMsQ0FBQztBQUNsRSxVQUFJLENBQUMsc0JBQXNCLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLHFCQUFxQixDQUFDLENBQUM7QUFDeEUsVUFBSSxDQUFDLHNCQUFzQixFQUFFLENBQUM7S0FDL0I7Ozs7OztBQU1ELFFBQUksT0FBTyxDQUFDLGFBQWEsSUFBSSxPQUFPLENBQUMsc0JBQXNCLEtBQUssSUFBSSxJQUNoRSxPQUFPLENBQUMsU0FBUyxJQUNqQixPQUFPLENBQUMsaUJBQWlCLEVBQUU7QUFDN0IsVUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUN4Qjs7QUFFRCxRQUFJLENBQUMsWUFBWSxFQUFFLENBQUM7R0FDckI7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQTlGRyxPQUFLLFdBcUdULE9BQU8sR0FBQSxtQkFBRzs7OztBQUVSLEtBQUMsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLENBQUMsQ0FBQyxPQUFPLENBQUMsVUFBQyxJQUFJLEVBQUs7QUFDM0MsVUFBSSxXQUFXLEdBQUcsZ0NBQVksSUFBSSxDQUFDLENBQUM7QUFDcEMsVUFBSSxFQUFFLEdBQUcsT0FBSyxHQUFHLENBQUksSUFBSSxZQUFTLENBQUM7O0FBRW5DLFVBQUksRUFBRSxJQUFJLEVBQUUsQ0FBQyxtQkFBbUIsRUFBRTtBQUNoQyxVQUFFLENBQUMsbUJBQW1CLENBQUMsUUFBUSxFQUFFLGtCQUFjLFdBQVcsa0JBQWUsQ0FBQyxDQUFDO0FBQzNFLFVBQUUsQ0FBQyxtQkFBbUIsQ0FBQyxVQUFVLEVBQUUsa0JBQWMsV0FBVyxlQUFZLENBQUMsQ0FBQztBQUMxRSxVQUFFLENBQUMsbUJBQW1CLENBQUMsYUFBYSxFQUFFLGtCQUFjLFdBQVcsa0JBQWUsQ0FBQyxDQUFDO09BQ2pGO0tBQ0YsQ0FBQyxDQUFDOztBQUVILFNBQUssQ0FBQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7O0FBRXBDLG9CQUFNLE9BQU8sS0FBQSxNQUFFLENBQUM7R0FDakI7Ozs7Ozs7OztBQXJIRyxPQUFLLFdBNkhULFFBQVEsR0FBQSxvQkFBRztBQUNULFFBQUksRUFBRSxHQUFHLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDOzs7OztBQUszQixRQUFJLENBQUMsRUFBRSxJQUFJLElBQUksQ0FBQyx5QkFBeUIsQ0FBQyxLQUFLLEtBQUssRUFBRTs7O0FBR3BELFVBQUksRUFBRSxFQUFFO0FBQ04sWUFBTSxLQUFLLEdBQUcsRUFBRSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsQ0FBQztBQUNqQyxVQUFFLENBQUMsVUFBVSxDQUFDLFlBQVksQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDdEMsYUFBSyxDQUFDLG1CQUFtQixDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBQzlCLFVBQUUsR0FBRyxLQUFLLENBQUM7T0FDWixNQUFNO0FBQ0wsVUFBRSxHQUFHLDRCQUFTLGFBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQzs7O0FBR3JDLFlBQUksYUFBYSxHQUFHLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxJQUFJLEdBQUcsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUNoRixZQUFJLFVBQVUsR0FBRyxpQ0FBYSxFQUFFLEVBQUUsYUFBYSxDQUFDLENBQUM7QUFDakQsWUFBSSxDQUFDLE9BQU8sQ0FBQyxhQUFhLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxzQkFBc0IsS0FBSyxJQUFJLEVBQUU7QUFDM0UsaUJBQU8sVUFBVSxDQUFDLFFBQVEsQ0FBQztTQUM1Qjs7QUFFRCxXQUFHLENBQUMsZUFBZSxDQUFDLEVBQUUsRUFDcEIsMEJBQU8sVUFBVSxFQUFFO0FBQ2pCLFlBQUUsRUFBRSxJQUFJLENBQUMsUUFBUSxDQUFDLE1BQU07QUFDeEIsbUJBQU8sVUFBVTtTQUNsQixDQUFDLENBQ0gsQ0FBQztPQUNIO0tBQ0Y7OztBQUdELFFBQUksYUFBYSxHQUFHLENBQUMsVUFBVSxFQUFDLFNBQVMsRUFBQyxNQUFNLEVBQUMsT0FBTyxDQUFDLENBQUM7QUFDMUQsU0FBSyxJQUFJLENBQUMsR0FBRyxhQUFhLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsRUFBRSxFQUFFO0FBQ2xELFVBQU0sSUFBSSxHQUFHLGFBQWEsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUM5QixVQUFJLGNBQWMsR0FBRyxFQUFFLENBQUM7QUFDeEIsVUFBSSxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEtBQUssV0FBVyxFQUFFO0FBQzlDLHNCQUFjLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQztPQUM1QztBQUNELFNBQUcsQ0FBQyxlQUFlLENBQUMsRUFBRSxFQUFFLGNBQWMsQ0FBQyxDQUFDO0tBQ3pDOztBQUVELFdBQU8sRUFBRSxDQUFDOztHQUVYOzs7Ozs7O0FBM0tHLE9BQUssV0FpTFQsZUFBZSxHQUFBLHlCQUFDLEVBQUUsRUFBRTs7O0FBQ2xCLFFBQUksRUFBRSxDQUFDLFlBQVksS0FBSyxDQUFDLElBQUksRUFBRSxDQUFDLFlBQVksS0FBSyxDQUFDLEVBQUU7OztBQUdsRCxhQUFPO0tBQ1I7O0FBRUQsUUFBSSxFQUFFLENBQUMsVUFBVSxLQUFLLENBQUMsRUFBRTs7Ozs7Ozs7Ozs7O0FBV3ZCLFlBQUksY0FBYyxHQUFHLEtBQUssQ0FBQztBQUMzQixZQUFJLGlCQUFpQixHQUFHLFNBQXBCLGlCQUFpQixHQUFjO0FBQ2pDLHdCQUFjLEdBQUcsSUFBSSxDQUFDO1NBQ3ZCLENBQUM7QUFDRixlQUFLLEVBQUUsQ0FBQyxXQUFXLEVBQUUsaUJBQWlCLENBQUMsQ0FBQzs7QUFFeEMsWUFBSSxnQkFBZ0IsR0FBRyxTQUFuQixnQkFBZ0IsR0FBYzs7O0FBR2hDLGNBQUksQ0FBQyxjQUFjLEVBQUU7QUFDbkIsZ0JBQUksQ0FBQyxPQUFPLENBQUMsV0FBVyxDQUFDLENBQUM7V0FDM0I7U0FDRixDQUFDO0FBQ0YsZUFBSyxFQUFFLENBQUMsZ0JBQWdCLEVBQUUsZ0JBQWdCLENBQUMsQ0FBQzs7QUFFNUMsZUFBSyxLQUFLLENBQUMsWUFBVTtBQUNuQixjQUFJLENBQUMsR0FBRyxDQUFDLFdBQVcsRUFBRSxpQkFBaUIsQ0FBQyxDQUFDO0FBQ3pDLGNBQUksQ0FBQyxHQUFHLENBQUMsZ0JBQWdCLEVBQUUsZ0JBQWdCLENBQUMsQ0FBQzs7QUFFN0MsY0FBSSxDQUFDLGNBQWMsRUFBRTs7QUFFbkIsZ0JBQUksQ0FBQyxPQUFPLENBQUMsV0FBVyxDQUFDLENBQUM7V0FDM0I7U0FDRixDQUFDLENBQUM7O0FBRUg7O1VBQU87Ozs7S0FDUjs7Ozs7O0FBTUQsUUFBSSxlQUFlLEdBQUcsQ0FBQyxXQUFXLENBQUMsQ0FBQzs7O0FBR3BDLG1CQUFlLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDLENBQUM7OztBQUd2QyxRQUFJLEVBQUUsQ0FBQyxVQUFVLElBQUksQ0FBQyxFQUFFO0FBQ3RCLHFCQUFlLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDO0tBQ3BDOzs7QUFHRCxRQUFJLEVBQUUsQ0FBQyxVQUFVLElBQUksQ0FBQyxFQUFFO0FBQ3RCLHFCQUFlLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDO0tBQ2pDOzs7QUFHRCxRQUFJLEVBQUUsQ0FBQyxVQUFVLElBQUksQ0FBQyxFQUFFO0FBQ3RCLHFCQUFlLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDLENBQUM7S0FDeEM7OztBQUdELFFBQUksQ0FBQyxLQUFLLENBQUMsWUFBVTtBQUNuQixxQkFBZSxDQUFDLE9BQU8sQ0FBQyxVQUFTLElBQUksRUFBQztBQUNwQyxZQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO09BQ3BCLEVBQUUsSUFBSSxDQUFDLENBQUM7S0FDVixDQUFDLENBQUM7R0FDSjs7QUE3UEcsT0FBSyxXQStQVCxzQkFBc0IsR0FBQSxrQ0FBRztBQUN2QixRQUFJLEVBQUUsR0FBRyxJQUFJLENBQUMsRUFBRSxFQUFFLENBQUMsVUFBVSxDQUFDOztBQUU5QixRQUFJLEVBQUUsRUFBRTs7O0FBR04sV0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDbEMsWUFBSSxDQUFDLFVBQVUsRUFBRSxDQUFDLFNBQVMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztPQUNwQzs7QUFFRCxVQUFJLEVBQUUsQ0FBQyxnQkFBZ0IsRUFBRTtBQUN2QixVQUFFLENBQUMsZ0JBQWdCLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO0FBQzNELFVBQUUsQ0FBQyxnQkFBZ0IsQ0FBQyxVQUFVLEVBQUUsSUFBSSxDQUFDLG1CQUFtQixDQUFDLENBQUM7QUFDMUQsVUFBRSxDQUFDLGdCQUFnQixDQUFDLGFBQWEsRUFBRSxJQUFJLENBQUMsc0JBQXNCLENBQUMsQ0FBQztPQUNqRTtLQUNGO0dBQ0Y7O0FBL1FHLE9BQUssV0FpUlQscUJBQXFCLEdBQUEsK0JBQUMsQ0FBQyxFQUFFO0FBQ3ZCLFFBQUksRUFBRSxHQUFHLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQztBQUMzQixRQUFJLENBQUMsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO0FBQ3hCLFVBQUksRUFBRSxRQUFRO0FBQ2QsWUFBTSxFQUFFLEVBQUU7QUFDVixtQkFBYSxFQUFFLEVBQUU7QUFDakIsZ0JBQVUsRUFBRSxFQUFFO0tBQ2YsQ0FBQyxDQUFDO0dBQ0o7O0FBelJHLE9BQUssV0EyUlQsa0JBQWtCLEdBQUEsNEJBQUMsQ0FBQyxFQUFFO0FBQ3BCLFFBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDO0dBQ3RDOztBQTdSRyxPQUFLLFdBK1JULHFCQUFxQixHQUFBLCtCQUFDLENBQUMsRUFBRTtBQUN2QixRQUFJLENBQUMsVUFBVSxFQUFFLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQztHQUN6Qzs7QUFqU0csT0FBSyxXQW1TVCx1QkFBdUIsR0FBQSxpQ0FBQyxDQUFDLEVBQUU7QUFDekIsUUFBSSxFQUFFLEdBQUcsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDO0FBQzVCLFFBQUksQ0FBQyxXQUFXLEVBQUUsQ0FBQyxPQUFPLENBQUM7QUFDekIsVUFBSSxFQUFFLFFBQVE7QUFDZCxZQUFNLEVBQUUsRUFBRTtBQUNWLG1CQUFhLEVBQUUsRUFBRTtBQUNqQixnQkFBVSxFQUFFLEVBQUU7S0FDZixDQUFDLENBQUM7R0FDSjs7QUEzU0csT0FBSyxXQTZTVCxvQkFBb0IsR0FBQSw4QkFBQyxDQUFDLEVBQUU7QUFDdEIsUUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUM7R0FDdkM7O0FBL1NHLE9BQUssV0FpVFQsdUJBQXVCLEdBQUEsaUNBQUMsQ0FBQyxFQUFFO0FBQ3pCLFFBQUksQ0FBQyxXQUFXLEVBQUUsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDO0dBQzFDOztBQW5URyxPQUFLLFdBcVRULHVCQUF1QixHQUFBLGlDQUFDLENBQUMsRUFBRTtBQUN6QixRQUFJLGNBQWMsR0FBRyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUM7QUFDeEMsUUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDLE9BQU8sQ0FBQztBQUN6QixVQUFJLEVBQUUsUUFBUTtBQUNkLFlBQU0sRUFBRSxjQUFjO0FBQ3RCLG1CQUFhLEVBQUUsY0FBYztBQUM3QixnQkFBVSxFQUFFLGNBQWM7S0FDM0IsQ0FBQyxDQUFDO0dBQ0o7O0FBN1RHLE9BQUssV0ErVFQsb0JBQW9CLEdBQUEsOEJBQUMsQ0FBQyxFQUFFO0FBQ3RCLFFBQUksQ0FBQyxXQUFXLEVBQUUsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDO0dBQ3ZDOztBQWpVRyxPQUFLLFdBbVVULHVCQUF1QixHQUFBLGlDQUFDLENBQUMsRUFBRTtBQUN6QixRQUFJLENBQUMsV0FBVyxFQUFFLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQztHQUMxQzs7Ozs7Ozs7QUFyVUcsT0FBSyxXQTZVVCxJQUFJLEdBQUEsZ0JBQUc7QUFDSCxRQUFJLE9BQU8sR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksRUFBRSxDQUFDO0FBQzlCLFFBQUksT0FBTztBQUNQLGFBQU8sU0FBTSxDQUFDLFlBQVUsRUFBRSxDQUFDLENBQUM7R0FDbkM7Ozs7Ozs7O0FBalZHLE9BQUssV0F3VlQsS0FBSyxHQUFBLGlCQUFHO0FBQUUsUUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLEVBQUUsQ0FBQztHQUFFOzs7Ozs7Ozs7QUF4VnpCLE9BQUssV0FnV1QsTUFBTSxHQUFBLGtCQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQztHQUFFOzs7Ozs7Ozs7QUFoV2hDLE9BQUssV0F3V1QsV0FBVyxHQUFBLHVCQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQztHQUFFOzs7Ozs7Ozs7QUF4VzFDLE9BQUssV0FnWFQsY0FBYyxHQUFBLHdCQUFDLE9BQU8sRUFBRTtBQUN0QixRQUFJO0FBQ0YsVUFBSSxDQUFDLEdBQUcsQ0FBQyxXQUFXLEdBQUcsT0FBTyxDQUFDO0tBQ2hDLENBQUMsT0FBTSxDQUFDLEVBQUU7QUFDVCw4QkFBSSxDQUFDLEVBQUUsZ0NBQWdDLENBQUMsQ0FBQzs7S0FFMUM7R0FDRjs7Ozs7Ozs7O0FBdlhHLE9BQUssV0ErWFQsUUFBUSxHQUFBLG9CQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLFFBQVEsSUFBSSxDQUFDLENBQUM7R0FBRTs7Ozs7Ozs7Ozs7QUEvWHpDLE9BQUssV0F5WVQsUUFBUSxHQUFBLG9CQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQztHQUFFOzs7Ozs7Ozs7QUF6WXBDLE9BQUssV0FpWlQsTUFBTSxHQUFBLGtCQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQztHQUFFOzs7Ozs7Ozs7QUFqWmhDLE9BQUssV0F5WlQsU0FBUyxHQUFBLG1CQUFDLGdCQUFnQixFQUFFO0FBQUUsUUFBSSxDQUFDLEdBQUcsQ0FBQyxNQUFNLEdBQUcsZ0JBQWdCLENBQUM7R0FBRTs7Ozs7Ozs7O0FBelovRCxPQUFLLFdBaWFULEtBQUssR0FBQSxpQkFBRztBQUFFLFdBQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUM7R0FBRTs7Ozs7Ozs7O0FBamE5QixPQUFLLFdBeWFULFFBQVEsR0FBQSxrQkFBQyxLQUFLLEVBQUU7QUFBRSxRQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7R0FBRTs7Ozs7Ozs7O0FBemF2QyxPQUFLLFdBaWJULEtBQUssR0FBQSxpQkFBRztBQUFFLFdBQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUM7R0FBRTs7Ozs7Ozs7O0FBamJwQyxPQUFLLFdBeWJULE1BQU0sR0FBQSxrQkFBRztBQUFHLFdBQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxZQUFZLENBQUM7R0FBRTs7Ozs7Ozs7O0FBemJ2QyxPQUFLLFdBaWNULGtCQUFrQixHQUFBLDhCQUFHO0FBQ25CLFFBQUksT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLHFCQUFxQixLQUFLLFVBQVUsRUFBRTtBQUN4RCxVQUFJLFNBQVMsR0FBRywwQkFBTyxTQUFTLENBQUMsU0FBUyxDQUFDOztBQUUzQyxVQUFJLFNBQVMsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLEVBQUU7QUFDeEUsZUFBTyxJQUFJLENBQUM7T0FDYjtLQUNGO0FBQ0QsV0FBTyxLQUFLLENBQUM7R0FDZDs7Ozs7Ozs7QUExY0csT0FBSyxXQWlkVCxlQUFlLEdBQUEsMkJBQUc7QUFDaEIsUUFBSSxLQUFLLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQzs7QUFFckIsUUFBSSw0QkFBNEIsSUFBSSxLQUFLLEVBQUU7QUFDekMsVUFBSSxDQUFDLEdBQUcsQ0FBQyx1QkFBdUIsRUFBRSxZQUFXO0FBQzNDLFlBQUksQ0FBQyxHQUFHLENBQUMscUJBQXFCLEVBQUUsWUFBVztBQUN6QyxjQUFJLENBQUMsT0FBTyxDQUFDLGtCQUFrQixFQUFFLEVBQUUsWUFBWSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7U0FDM0QsQ0FBQyxDQUFDOztBQUVILFlBQUksQ0FBQyxPQUFPLENBQUMsa0JBQWtCLEVBQUUsRUFBRSxZQUFZLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQztPQUMxRCxDQUFDLENBQUM7S0FDSjs7QUFFRCxRQUFJLEtBQUssQ0FBQyxNQUFNLElBQUksS0FBSyxDQUFDLFlBQVksSUFBSSxLQUFLLENBQUMsYUFBYSxFQUFFOzs7QUFHM0QsVUFBSSxDQUFDLElBQUksRUFBRSxDQUFDOzs7O0FBSWQsVUFBSSxDQUFDLFVBQVUsQ0FBQyxZQUFVO0FBQ3hCLGFBQUssQ0FBQyxLQUFLLEVBQUUsQ0FBQztBQUNkLGFBQUssQ0FBQyxxQkFBcUIsRUFBRSxDQUFDO09BQy9CLEVBQUUsQ0FBQyxDQUFDLENBQUM7S0FDUCxNQUFNO0FBQ0wsV0FBSyxDQUFDLHFCQUFxQixFQUFFLENBQUM7S0FDL0I7R0FDRjs7Ozs7Ozs7QUE1ZUcsT0FBSyxXQW1mVCxjQUFjLEdBQUEsMEJBQUc7QUFDZixRQUFJLENBQUMsR0FBRyxDQUFDLG9CQUFvQixFQUFFLENBQUM7R0FDakM7Ozs7Ozs7Ozs7QUFyZkcsT0FBSyxXQThmVCxHQUFHLEdBQUEsYUFBQyxJQUFHLEVBQUU7QUFDUCxRQUFJLElBQUcsS0FBSyxTQUFTLEVBQUU7QUFDckIsYUFBTyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQztLQUNyQixNQUFNOztBQUVMLFVBQUksQ0FBQyxNQUFNLENBQUMsSUFBRyxDQUFDLENBQUM7S0FDbEI7R0FDRjs7Ozs7Ozs7OztBQXJnQkcsT0FBSyxXQThnQlQsTUFBTSxHQUFBLGdCQUFDLEdBQUcsRUFBRTtBQUNWLFFBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQztHQUNwQjs7Ozs7Ozs7QUFoaEJHLE9BQUssV0F1aEJULElBQUksR0FBQSxnQkFBRTtBQUNKLFFBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxFQUFFLENBQUM7R0FDakI7Ozs7Ozs7O0FBemhCRyxPQUFLLFdBZ2lCVCxLQUFLLEdBQUEsaUJBQUc7QUFDTixTQUFLLENBQUMsaUJBQWlCLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0dBQ25DOzs7Ozs7Ozs7QUFsaUJHLE9BQUssV0EwaUJULFVBQVUsR0FBQSxzQkFBRztBQUNYLFFBQUksSUFBSSxDQUFDLGNBQWMsRUFBRTtBQUN2QixhQUFPLElBQUksQ0FBQyxjQUFjLENBQUMsR0FBRyxDQUFDO0tBQ2hDLE1BQU07QUFDTCxhQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDO0tBQzVCO0dBQ0Y7Ozs7Ozs7OztBQWhqQkcsT0FBSyxXQXdqQlQsTUFBTSxHQUFBLGtCQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQztHQUFFOzs7Ozs7Ozs7QUF4akJoQyxPQUFLLFdBZ2tCVCxTQUFTLEdBQUEsbUJBQUMsR0FBRyxFQUFFO0FBQUUsUUFBSSxDQUFDLEdBQUcsQ0FBQyxNQUFNLEdBQUcsR0FBRyxDQUFDO0dBQUU7Ozs7Ozs7OztBQWhrQnJDLE9BQUssV0F3a0JULE9BQU8sR0FBQSxtQkFBRztBQUFFLFdBQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUM7R0FBRTs7Ozs7Ozs7O0FBeGtCbEMsT0FBSyxXQWdsQlQsVUFBVSxHQUFBLG9CQUFDLEdBQUcsRUFBRTtBQUFFLFFBQUksQ0FBQyxHQUFHLENBQUMsT0FBTyxHQUFHLEdBQUcsQ0FBQztHQUFFOzs7Ozs7Ozs7QUFobEJ2QyxPQUFLLFdBd2xCVCxRQUFRLEdBQUEsb0JBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsUUFBUSxDQUFDO0dBQUU7Ozs7Ozs7OztBQXhsQnBDLE9BQUssV0FnbUJULFdBQVcsR0FBQSxxQkFBQyxHQUFHLEVBQUU7QUFBRSxRQUFJLENBQUMsR0FBRyxDQUFDLFFBQVEsR0FBRyxHQUFHLENBQUM7R0FBRTs7Ozs7Ozs7O0FBaG1CekMsT0FBSyxXQXdtQlQsUUFBUSxHQUFBLG9CQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQztHQUFFOzs7Ozs7Ozs7QUF4bUJwQyxPQUFLLFdBZ25CVCxXQUFXLEdBQUEscUJBQUMsR0FBRyxFQUFFO0FBQUUsUUFBSSxDQUFDLEdBQUcsQ0FBQyxRQUFRLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQztHQUFFOzs7Ozs7Ozs7QUFobkIzQyxPQUFLLFdBd25CVCxJQUFJLEdBQUEsZ0JBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDO0dBQUU7Ozs7Ozs7OztBQXhuQjVCLE9BQUssV0Fnb0JULE9BQU8sR0FBQSxpQkFBQyxHQUFHLEVBQUU7QUFBRSxRQUFJLENBQUMsR0FBRyxDQUFDLElBQUksR0FBRyxHQUFHLENBQUM7R0FBRTs7Ozs7Ozs7O0FBaG9CakMsT0FBSyxXQXdvQlQsS0FBSyxHQUFBLGlCQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQztHQUFFOzs7Ozs7Ozs7QUF4b0I5QixPQUFLLFdBZ3BCVCxPQUFPLEdBQUEsbUJBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDO0dBQUU7Ozs7Ozs7Ozs7O0FBaHBCbEMsT0FBSyxXQTBwQlQsUUFBUSxHQUFBLG9CQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQztHQUFFOzs7Ozs7Ozs7QUExcEJwQyxPQUFLLFdBa3FCVCxLQUFLLEdBQUEsaUJBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDO0dBQUU7Ozs7Ozs7Ozs7O0FBbHFCOUIsT0FBSyxXQTRxQlQsWUFBWSxHQUFBLHdCQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLFlBQVksQ0FBQztHQUFFOzs7Ozs7Ozs7QUE1cUI1QyxPQUFLLFdBb3JCVCxZQUFZLEdBQUEsd0JBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsWUFBWSxDQUFDO0dBQUU7Ozs7Ozs7Ozs7QUFwckI1QyxPQUFLLFdBNnJCVCxNQUFNLEdBQUEsa0JBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDO0dBQUU7Ozs7Ozs7OztBQTdyQmhDLE9BQUssV0Fxc0JULGVBQWUsR0FBQSx5QkFBQyxHQUFHLEVBQUU7QUFBRSxRQUFJLENBQUMsR0FBRyxDQUFDLFlBQVksR0FBRyxHQUFHLENBQUM7R0FBRTs7Ozs7Ozs7Ozs7Ozs7QUFyc0JqRCxPQUFLLFdBa3RCVCxZQUFZLEdBQUEsd0JBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsWUFBWSxDQUFDO0dBQUU7Ozs7Ozs7Ozs7Ozs7Ozs7QUFsdEI1QyxPQUFLLFdBaXVCVCxVQUFVLEdBQUEsc0JBQUc7QUFBRSxXQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDO0dBQUU7Ozs7Ozs7OztBQWp1QnhDLE9BQUssV0F5dUJULFVBQVUsR0FBQSxzQkFBRztBQUFFLFdBQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7R0FBRTs7Ozs7Ozs7O0FBenVCeEMsT0FBSyxXQWl2QlQsV0FBVyxHQUFBLHVCQUFHO0FBQUUsV0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQztHQUFFOzs7Ozs7Ozs7QUFqdkIxQyxPQUFLLFdBeXZCVCxVQUFVLEdBQUEsc0JBQUc7QUFDWCxXQUFPLGdCQUFNLFVBQVUsS0FBQSxNQUFFLENBQUM7R0FDM0I7Ozs7Ozs7Ozs7Ozs7QUEzdkJHLE9BQUssV0F1d0JULFlBQVksR0FBQSxzQkFBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtBQUNsQyxRQUFJLENBQUMsSUFBSSxDQUFDLDBCQUEwQixDQUFDLEVBQUU7QUFDckMsYUFBTyxnQkFBTSxZQUFZLEtBQUEsT0FBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0tBQ2xEOztBQUVELFdBQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxZQUFZLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxRQUFRLENBQUMsQ0FBQztHQUNyRDs7Ozs7Ozs7Ozs7QUE3d0JHLE9BQUssV0F1eEJULGtCQUFrQixHQUFBLDhCQUFhO1FBQVosT0FBTyx5REFBQyxFQUFFOztBQUMzQixRQUFJLENBQUMsSUFBSSxDQUFDLDBCQUEwQixDQUFDLEVBQUU7QUFDckMsYUFBTyxnQkFBTSxrQkFBa0IsS0FBQSxPQUFDLE9BQU8sQ0FBQyxDQUFDO0tBQzFDOztBQUVELFFBQUksZ0JBQWdCLEdBQUcsNEJBQVMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDOztBQUV2RCxRQUFJLE9BQU8sQ0FBQyxJQUFJLEVBQUU7QUFDaEIsc0JBQWdCLENBQUMsSUFBSSxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUM7S0FDdEM7QUFDRCxRQUFJLE9BQU8sQ0FBQyxLQUFLLEVBQUU7QUFDakIsc0JBQWdCLENBQUMsS0FBSyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUM7S0FDeEM7QUFDRCxRQUFJLE9BQU8sQ0FBQyxRQUFRLElBQUksT0FBTyxDQUFDLE9BQU8sRUFBRTtBQUN2QyxzQkFBZ0IsQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDLFFBQVEsSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDO0tBQ2hFO0FBQ0QsUUFBSSxPQUFPLFdBQVEsRUFBRTtBQUNuQixzQkFBZ0IsV0FBUSxHQUFHLE9BQU8sV0FBUSxDQUFDO0tBQzVDO0FBQ0QsUUFBSSxPQUFPLENBQUMsRUFBRSxFQUFFO0FBQ2Qsc0JBQWdCLENBQUMsRUFBRSxHQUFHLE9BQU8sQ0FBQyxFQUFFLENBQUM7S0FDbEM7QUFDRCxRQUFJLE9BQU8sQ0FBQyxHQUFHLEVBQUU7QUFDZixzQkFBZ0IsQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQztLQUNwQzs7QUFFRCxRQUFJLENBQUMsRUFBRSxFQUFFLENBQUMsV0FBVyxDQUFDLGdCQUFnQixDQUFDLENBQUM7OztBQUd4QyxRQUFJLENBQUMsa0JBQWtCLEVBQUUsQ0FBQyxnQkFBZ0IsQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDO0FBQzdELFFBQUksQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDLFNBQVMsQ0FBQyxnQkFBZ0IsQ0FBQyxLQUFLLENBQUMsQ0FBQzs7QUFFMUQsV0FBTyxnQkFBZ0IsQ0FBQztHQUN6Qjs7Ozs7Ozs7O0FBeHpCRyxPQUFLLFdBZzBCVCxxQkFBcUIsR0FBQSwrQkFBQyxLQUFLLEVBQUU7QUFDM0IsUUFBSSxDQUFDLElBQUksQ0FBQywwQkFBMEIsQ0FBQyxFQUFFO0FBQ3JDLGFBQU8sZ0JBQU0scUJBQXFCLEtBQUEsT0FBQyxLQUFLLENBQUMsQ0FBQztLQUMzQzs7QUFFRCxRQUFJLE1BQU0sWUFBQTtRQUFFLENBQUMsWUFBQSxDQUFDOztBQUVkLFFBQUksWUFBWSxHQUFHLElBQUksQ0FBQyxrQkFBa0IsRUFBRSxDQUFDLHVCQUF1QixDQUFDLEtBQUssQ0FBQyxDQUFDOzs7QUFHNUUsUUFBSSxDQUFDLGtCQUFrQixFQUFFLENBQUMsbUJBQW1CLENBQUMsWUFBWSxDQUFDLENBQUM7QUFDNUQsUUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUMsWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFDOztBQUU1QyxVQUFNLEdBQUcsSUFBSSxDQUFDLEVBQUUsQ0FBQyxPQUFPLENBQUMsQ0FBQzs7QUFFMUIsS0FBQyxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUM7QUFDbEIsV0FBTyxDQUFDLEVBQUUsRUFBRTtBQUNWLFVBQUksS0FBSyxLQUFLLE1BQU0sQ0FBQyxDQUFDLENBQUMsSUFBSSxLQUFLLEtBQUssTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssRUFBRTtBQUNwRCxZQUFJLENBQUMsRUFBRSxFQUFFLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO09BQ2xDO0tBQ0Y7R0FDRjs7U0FyMUJHLEtBQUs7OztBQW0yQlgsS0FBSyxDQUFDLFFBQVEsR0FBRyw0QkFBUyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7QUFDakQsSUFBSSxLQUFLLEdBQUcsNEJBQVMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0FBQzVDLEtBQUssQ0FBQyxJQUFJLEdBQUcsVUFBVSxDQUFDO0FBQ3hCLEtBQUssQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO0FBQ3JCLEtBQUssQ0FBQyxLQUFLLEdBQUcsU0FBUyxDQUFDO0FBQ3hCLEtBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDOzs7Ozs7O0FBT2xDLEtBQUssQ0FBQyxXQUFXLEdBQUcsWUFBVTs7QUFFNUIsTUFBSTtBQUNGLFNBQUssQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDLEdBQUcsR0FBRyxDQUFDO0dBQ2hDLENBQUMsT0FBTyxDQUFDLEVBQUU7QUFDVixXQUFPLEtBQUssQ0FBQztHQUNkOztBQUVELFNBQU8sQ0FBQyxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDO0NBQ3JDLENBQUM7OztBQUdGLG9CQUFLLGtCQUFrQixDQUFDLEtBQUssQ0FBQyxDQUFDOzs7Ozs7Ozs7QUFTL0IsS0FBSyxDQUFDLG1CQUFtQixHQUFHLEVBQUUsQ0FBQzs7Ozs7Ozs7QUFRL0IsS0FBSyxDQUFDLG1CQUFtQixDQUFDLFdBQVcsR0FBRyxVQUFTLElBQUksRUFBQzs7O0FBR3BELE1BQUk7QUFDRixXQUFPLEtBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxDQUFDO0dBQ3pDLENBQUMsT0FBTSxDQUFDLEVBQUU7QUFDVCxXQUFPLEVBQUUsQ0FBQztHQUNYO0NBQ0YsQ0FBQzs7Ozs7Ozs7QUFRRixLQUFLLENBQUMsbUJBQW1CLENBQUMsZUFBZSxHQUFHLFVBQVMsTUFBTSxFQUFDO0FBQzFELE1BQUksS0FBSyxFQUFFLEdBQUcsQ0FBQzs7O0FBR2YsTUFBSSxNQUFNLENBQUMsSUFBSSxFQUFFO0FBQ2YsV0FBTyxLQUFLLENBQUMsbUJBQW1CLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQztHQUMzRCxNQUFNLElBQUksTUFBTSxDQUFDLEdBQUcsRUFBRTs7QUFFckIsT0FBRyxHQUFHLEdBQUcsQ0FBQyxnQkFBZ0IsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUM7O0FBRXZDLFdBQU8sS0FBSyxDQUFDLG1CQUFtQixDQUFDLFdBQVcsWUFBVSxHQUFHLENBQUcsQ0FBQztHQUM5RDs7QUFFRCxTQUFPLEVBQUUsQ0FBQztDQUNYLENBQUM7Ozs7Ozs7Ozs7O0FBV0YsS0FBSyxDQUFDLG1CQUFtQixDQUFDLFlBQVksR0FBRyxVQUFTLE1BQU0sRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFDO0FBQ3RFLE1BQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0NBQ3pCLENBQUM7Ozs7OztBQU1GLEtBQUssQ0FBQyxtQkFBbUIsQ0FBQyxPQUFPLEdBQUcsWUFBVSxFQUFFLENBQUM7OztBQUdqRCxLQUFLLENBQUMscUJBQXFCLENBQUMsS0FBSyxDQUFDLG1CQUFtQixDQUFDLENBQUM7Ozs7Ozs7OztBQVN2RCxLQUFLLENBQUMsZ0JBQWdCLEdBQUcsWUFBVTtBQUNqQyxNQUFJLE1BQU0sR0FBSSxLQUFLLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQztBQUNwQyxPQUFLLENBQUMsUUFBUSxDQUFDLE1BQU0sR0FBRyxBQUFDLE1BQU0sR0FBRyxDQUFDLEdBQUksR0FBRyxDQUFDO0FBQzNDLFNBQU8sTUFBTSxLQUFLLEtBQUssQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDO0NBQ3pDLENBQUM7Ozs7Ozs7QUFPRixLQUFLLENBQUMsc0JBQXNCLEdBQUcsWUFBVTs7O0FBR3ZDLE1BQUksT0FBTyxDQUFDLFVBQVUsSUFBSSxPQUFPLENBQUMsU0FBUyxFQUFFO0FBQzNDLFdBQU8sS0FBSyxDQUFDO0dBQ2Q7QUFDRCxNQUFJLFlBQVksR0FBRyxLQUFLLENBQUMsUUFBUSxDQUFDLFlBQVksQ0FBQztBQUMvQyxPQUFLLENBQUMsUUFBUSxDQUFDLFlBQVksR0FBRyxBQUFDLFlBQVksR0FBRyxDQUFDLEdBQUksR0FBRyxDQUFDO0FBQ3ZELFNBQU8sWUFBWSxLQUFLLEtBQUssQ0FBQyxRQUFRLENBQUMsWUFBWSxDQUFDO0NBQ3JELENBQUM7Ozs7Ozs7QUFPRixLQUFLLENBQUMsd0JBQXdCLEdBQUcsWUFBVztBQUMxQyxNQUFJLGtCQUFrQixDQUFDOzs7Ozs7O0FBT3ZCLG9CQUFrQixHQUFHLENBQUMsQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQztBQUNqRCxNQUFJLGtCQUFrQixJQUFJLEtBQUssQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUU7QUFDOUQsc0JBQWtCLEdBQUcsT0FBTyxLQUFLLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsS0FBSyxRQUFRLENBQUM7R0FDL0U7QUFDRCxNQUFJLGtCQUFrQixJQUFJLE9BQU8sQ0FBQyxVQUFVLEVBQUU7QUFDNUMsc0JBQWtCLEdBQUcsS0FBSyxDQUFDO0dBQzVCO0FBQ0QsTUFBSSxrQkFBa0IsSUFBSSxFQUFFLGVBQWUsSUFBSSxLQUFLLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQSxBQUFDLEVBQUU7QUFDekUsc0JBQWtCLEdBQUcsS0FBSyxDQUFDO0dBQzVCOztBQUVELFNBQU8sa0JBQWtCLENBQUM7Q0FDM0IsQ0FBQzs7Ozs7OztBQU9GLEtBQUssQ0FBQyx5QkFBeUIsR0FBRyxZQUFXO0FBQzNDLE1BQUksbUJBQW1CLEdBQUcsQ0FBQyxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDO0FBQ3ZELFNBQU8sbUJBQW1CLENBQUM7Q0FDNUIsQ0FBQzs7Ozs7OztBQU9GLEtBQUssQ0FBQyx5QkFBeUIsR0FBRyxZQUFXO0FBQzNDLE1BQUksbUJBQW1CLEdBQUcsQ0FBQyxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDO0FBQ3ZELFNBQU8sbUJBQW1CLENBQUM7Q0FDNUIsQ0FBQzs7Ozs7Ozs7QUFTRixLQUFLLENBQUMsTUFBTSxHQUFHLENBQ2IsV0FBVyxFQUNYLFNBQVMsRUFDVCxPQUFPLEVBQ1AsT0FBTyxFQUNQLFNBQVMsRUFDVCxTQUFTLEVBQ1QsZ0JBQWdCLEVBQ2hCLFlBQVksRUFDWixTQUFTLEVBQ1QsZ0JBQWdCLEVBQ2hCLFNBQVMsRUFDVCxTQUFTLEVBQ1QsU0FBUyxFQUNULFFBQVEsRUFDUixPQUFPLEVBQ1AsZ0JBQWdCLEVBQ2hCLFlBQVksRUFDWixVQUFVLEVBQ1YsTUFBTSxFQUNOLE9BQU8sRUFDUCxZQUFZLEVBQ1osY0FBYyxDQUNmLENBQUM7Ozs7Ozs7QUFPRixLQUFLLENBQUMsU0FBUyxDQUFDLHVCQUF1QixDQUFDLEdBQUcsS0FBSyxDQUFDLGdCQUFnQixFQUFFLENBQUM7Ozs7Ozs7QUFPcEUsS0FBSyxDQUFDLFNBQVMsQ0FBQyxzQkFBc0IsQ0FBQyxHQUFHLEtBQUssQ0FBQyxzQkFBc0IsRUFBRSxDQUFDOzs7Ozs7OztBQVF6RSxLQUFLLENBQUMsU0FBUyxDQUFDLHlCQUF5QixDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDOzs7Ozs7O0FBTzdELEtBQUssQ0FBQyxTQUFTLENBQUMsMEJBQTBCLENBQUMsR0FBRyxJQUFJLENBQUM7Ozs7OztBQU1uRCxLQUFLLENBQUMsU0FBUyxDQUFDLHdCQUF3QixDQUFDLEdBQUcsSUFBSSxDQUFDOzs7Ozs7O0FBT2pELEtBQUssQ0FBQyxTQUFTLENBQUMsMEJBQTBCLENBQUMsR0FBRyxLQUFLLENBQUMsd0JBQXdCLEVBQUUsQ0FBQzs7Ozs7OztBQU8vRSxLQUFLLENBQUMsU0FBUyxDQUFDLDJCQUEyQixDQUFDLEdBQUcsS0FBSyxDQUFDLHlCQUF5QixFQUFFLENBQUM7Ozs7Ozs7QUFPakYsS0FBSyxDQUFDLFNBQVMsQ0FBQywyQkFBMkIsQ0FBQyxHQUFHLEtBQUssQ0FBQyx5QkFBeUIsRUFBRSxDQUFDOzs7QUFHakYsSUFBSSxXQUFXLFlBQUEsQ0FBQztBQUNoQixJQUFNLFNBQVMsR0FBRywyQ0FBMkMsQ0FBQztBQUM5RCxJQUFNLEtBQUssR0FBRyxjQUFjLENBQUM7O0FBRTdCLEtBQUssQ0FBQyxnQkFBZ0IsR0FBRyxZQUFXOztBQUVsQyxNQUFJLE9BQU8sQ0FBQyxlQUFlLElBQUksR0FBRyxFQUFFO0FBQ2xDLFFBQUksQ0FBQyxXQUFXLEVBQUU7QUFDaEIsaUJBQVcsR0FBRyxLQUFLLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDO0tBQ2hFOztBQUVELFNBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLFNBQVMsQ0FBQyxXQUFXLEdBQUcsVUFBUyxJQUFJLEVBQUU7QUFDaEUsVUFBSSxJQUFJLElBQUksU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRTtBQUNoQyxlQUFPLE9BQU8sQ0FBQztPQUNoQjtBQUNELGFBQU8sV0FBVyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7S0FDckMsQ0FBQztHQUNIOzs7QUFHRCxNQUFJLE9BQU8sQ0FBQyxjQUFjLEVBQUU7QUFDMUIsUUFBSSxDQUFDLFdBQVcsRUFBRTtBQUNoQixpQkFBVyxHQUFHLEtBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUM7S0FDaEU7O0FBRUQsU0FBSyxDQUFDLFFBQVEsQ0FBQyxXQUFXLENBQUMsU0FBUyxDQUFDLFdBQVcsR0FBRyxVQUFTLElBQUksRUFBQztBQUMvRCxVQUFJLElBQUksSUFBSSxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFO0FBQzVCLGVBQU8sT0FBTyxDQUFDO09BQ2hCO0FBQ0QsYUFBTyxXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztLQUNyQyxDQUFDO0dBQ0g7Q0FDRixDQUFDOztBQUVGLEtBQUssQ0FBQyxrQkFBa0IsR0FBRyxZQUFXO0FBQ3BDLE1BQUksQ0FBQyxHQUFHLEtBQUssQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUM7QUFDekQsT0FBSyxDQUFDLFFBQVEsQ0FBQyxXQUFXLENBQUMsU0FBUyxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7QUFDL0QsYUFBVyxHQUFHLElBQUksQ0FBQztBQUNuQixTQUFPLENBQUMsQ0FBQztDQUNWLENBQUM7OztBQUdGLEtBQUssQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDOztBQUV6QixLQUFLLENBQUMsbUJBQW1CLEdBQUcsVUFBUyxFQUFFLEVBQUM7QUFDdEMsTUFBSSxDQUFDLEVBQUUsRUFBRTtBQUFFLFdBQU87R0FBRTs7QUFFcEIsTUFBSSxFQUFFLENBQUMsVUFBVSxFQUFFO0FBQ2pCLE1BQUUsQ0FBQyxVQUFVLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0dBQy9COzs7QUFHRCxTQUFNLEVBQUUsQ0FBQyxhQUFhLEVBQUUsRUFBRTtBQUN4QixNQUFFLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxVQUFVLENBQUMsQ0FBQztHQUMvQjs7OztBQUlELElBQUUsQ0FBQyxlQUFlLENBQUMsS0FBSyxDQUFDLENBQUM7Ozs7QUFJMUIsTUFBSSxPQUFPLEVBQUUsQ0FBQyxJQUFJLEtBQUssVUFBVSxFQUFFOztBQUVqQyxLQUFDLFlBQVc7QUFDVixVQUFJO0FBQ0YsVUFBRSxDQUFDLElBQUksRUFBRSxDQUFDO09BQ1gsQ0FBQyxPQUFPLENBQUMsRUFBRTs7T0FFWDtLQUNGLENBQUEsRUFBRyxDQUFDO0dBQ047Q0FDRixDQUFDOztBQUVGLEtBQUssQ0FBQyxpQkFBaUIsR0FBRyxVQUFTLEVBQUUsRUFBQztBQUNwQyxNQUFJLENBQUMsRUFBRSxFQUFFO0FBQUUsV0FBTztHQUFFOztBQUVwQixNQUFJLE9BQU8sR0FBRyxFQUFFLENBQUMsZ0JBQWdCLENBQUMsUUFBUSxDQUFDLENBQUM7QUFDNUMsTUFBSSxDQUFDLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQztBQUN2QixTQUFPLENBQUMsRUFBRSxFQUFFO0FBQ1YsTUFBRSxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztHQUM1Qjs7OztBQUlELElBQUUsQ0FBQyxlQUFlLENBQUMsS0FBSyxDQUFDLENBQUM7O0FBRTFCLE1BQUksT0FBTyxFQUFFLENBQUMsSUFBSSxLQUFLLFVBQVUsRUFBRTs7QUFFakMsS0FBQyxZQUFXO0FBQ1YsVUFBSTtBQUNGLFVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQztPQUNYLENBQUMsT0FBTyxDQUFDLEVBQUUsRUFBRTtLQUNmLENBQUEsRUFBRyxDQUFDO0dBQ047Q0FDRixDQUFDOztBQUVGLHVCQUFVLGlCQUFpQixDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQztBQUM1QyxvQkFBSyxZQUFZLENBQUMsT0FBTyxFQUFFLEtBQUssQ0FBQyxDQUFDO3FCQUNuQixLQUFLIiwiZmlsZSI6InNyYy9qcy90ZWNoL2h0bWw1LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBAZmlsZSBodG1sNS5qc1xuICogSFRNTDUgTWVkaWEgQ29udHJvbGxlciAtIFdyYXBwZXIgZm9yIEhUTUw1IE1lZGlhIEFQSVxuICovXG5cbmltcG9ydCBUZWNoIGZyb20gJy4vdGVjaC5qcyc7XG5pbXBvcnQgQ29tcG9uZW50IGZyb20gJy4uL2NvbXBvbmVudCc7XG5pbXBvcnQgKiBhcyBEb20gZnJvbSAnLi4vdXRpbHMvZG9tLmpzJztcbmltcG9ydCAqIGFzIFVybCBmcm9tICcuLi91dGlscy91cmwuanMnO1xuaW1wb3J0ICogYXMgRm4gZnJvbSAnLi4vdXRpbHMvZm4uanMnO1xuaW1wb3J0IGxvZyBmcm9tICcuLi91dGlscy9sb2cuanMnO1xuaW1wb3J0IHRzbWwgZnJvbSAndHNtbCc7XG5pbXBvcnQgVGV4dFRyYWNrIGZyb20gJy4uLy4uLy4uL3NyYy9qcy90cmFja3MvdGV4dC10cmFjay5qcyc7XG5pbXBvcnQgKiBhcyBicm93c2VyIGZyb20gJy4uL3V0aWxzL2Jyb3dzZXIuanMnO1xuaW1wb3J0IGRvY3VtZW50IGZyb20gJ2dsb2JhbC9kb2N1bWVudCc7XG5pbXBvcnQgd2luZG93IGZyb20gJ2dsb2JhbC93aW5kb3cnO1xuaW1wb3J0IGFzc2lnbiBmcm9tICdvYmplY3QuYXNzaWduJztcbmltcG9ydCBtZXJnZU9wdGlvbnMgZnJvbSAnLi4vdXRpbHMvbWVyZ2Utb3B0aW9ucy5qcyc7XG5pbXBvcnQgdG9UaXRsZUNhc2UgZnJvbSAnLi4vdXRpbHMvdG8tdGl0bGUtY2FzZS5qcyc7XG5cbi8qKlxuICogSFRNTDUgTWVkaWEgQ29udHJvbGxlciAtIFdyYXBwZXIgZm9yIEhUTUw1IE1lZGlhIEFQSVxuICpcbiAqIEBwYXJhbSB7T2JqZWN0PX0gb3B0aW9ucyBPYmplY3Qgb2Ygb3B0aW9uIG5hbWVzIGFuZCB2YWx1ZXNcbiAqIEBwYXJhbSB7RnVuY3Rpb249fSByZWFkeSBSZWFkeSBjYWxsYmFjayBmdW5jdGlvblxuICogQGV4dGVuZHMgVGVjaFxuICogQGNsYXNzIEh0bWw1XG4gKi9cbmNsYXNzIEh0bWw1IGV4dGVuZHMgVGVjaCB7XG5cbiAgY29uc3RydWN0b3Iob3B0aW9ucywgcmVhZHkpe1xuICAgIHN1cGVyKG9wdGlvbnMsIHJlYWR5KTtcblxuICAgIGNvbnN0IHNvdXJjZSA9IG9wdGlvbnMuc291cmNlO1xuICAgIGxldCBjcm9zc29yaWdpblRyYWNrcyA9IGZhbHNlO1xuXG4gICAgLy8gU2V0IHRoZSBzb3VyY2UgaWYgb25lIGlzIHByb3ZpZGVkXG4gICAgLy8gMSkgQ2hlY2sgaWYgdGhlIHNvdXJjZSBpcyBuZXcgKGlmIG5vdCwgd2Ugd2FudCB0byBrZWVwIHRoZSBvcmlnaW5hbCBzbyBwbGF5YmFjayBpc24ndCBpbnRlcnJ1cHRlZClcbiAgICAvLyAyKSBDaGVjayB0byBzZWUgaWYgdGhlIG5ldHdvcmsgc3RhdGUgb2YgdGhlIHRhZyB3YXMgZmFpbGVkIGF0IGluaXQsIGFuZCBpZiBzbywgcmVzZXQgdGhlIHNvdXJjZVxuICAgIC8vIGFueXdheSBzbyB0aGUgZXJyb3IgZ2V0cyBmaXJlZC5cbiAgICBpZiAoc291cmNlICYmICh0aGlzLmVsXy5jdXJyZW50U3JjICE9PSBzb3VyY2Uuc3JjIHx8IChvcHRpb25zLnRhZyAmJiBvcHRpb25zLnRhZy5pbml0TmV0d29ya1N0YXRlXyA9PT0gMykpKSB7XG4gICAgICB0aGlzLnNldFNvdXJjZShzb3VyY2UpO1xuICAgIH0gZWxzZSB7XG4gICAgICB0aGlzLmhhbmRsZUxhdGVJbml0Xyh0aGlzLmVsXyk7XG4gICAgfVxuXG4gICAgaWYgKHRoaXMuZWxfLmhhc0NoaWxkTm9kZXMoKSkge1xuXG4gICAgICBsZXQgbm9kZXMgPSB0aGlzLmVsXy5jaGlsZE5vZGVzO1xuICAgICAgbGV0IG5vZGVzTGVuZ3RoID0gbm9kZXMubGVuZ3RoO1xuICAgICAgbGV0IHJlbW92ZU5vZGVzID0gW107XG5cbiAgICAgIHdoaWxlIChub2Rlc0xlbmd0aC0tKSB7XG4gICAgICAgIGxldCBub2RlID0gbm9kZXNbbm9kZXNMZW5ndGhdO1xuICAgICAgICBsZXQgbm9kZU5hbWUgPSBub2RlLm5vZGVOYW1lLnRvTG93ZXJDYXNlKCk7XG5cbiAgICAgICAgaWYgKG5vZGVOYW1lID09PSAndHJhY2snKSB7XG4gICAgICAgICAgaWYgKCF0aGlzLmZlYXR1cmVzTmF0aXZlVGV4dFRyYWNrcykge1xuICAgICAgICAgICAgLy8gRW1wdHkgdmlkZW8gdGFnIHRyYWNrcyBzbyB0aGUgYnVpbHQtaW4gcGxheWVyIGRvZXNuJ3QgdXNlIHRoZW0gYWxzby5cbiAgICAgICAgICAgIC8vIFRoaXMgbWF5IG5vdCBiZSBmYXN0IGVub3VnaCB0byBzdG9wIEhUTUw1IGJyb3dzZXJzIGZyb20gcmVhZGluZyB0aGUgdGFnc1xuICAgICAgICAgICAgLy8gc28gd2UnbGwgbmVlZCB0byB0dXJuIG9mZiBhbnkgZGVmYXVsdCB0cmFja3MgaWYgd2UncmUgbWFudWFsbHkgZG9pbmdcbiAgICAgICAgICAgIC8vIGNhcHRpb25zIGFuZCBzdWJ0aXRsZXMuIHZpZGVvRWxlbWVudC50ZXh0VHJhY2tzXG4gICAgICAgICAgICByZW1vdmVOb2Rlcy5wdXNoKG5vZGUpO1xuICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAvLyBzdG9yZSBIVE1MVHJhY2tFbGVtZW50IGFuZCBUZXh0VHJhY2sgdG8gcmVtb3RlIGxpc3RcbiAgICAgICAgICAgIHRoaXMucmVtb3RlVGV4dFRyYWNrRWxzKCkuYWRkVHJhY2tFbGVtZW50Xyhub2RlKTtcbiAgICAgICAgICAgIHRoaXMucmVtb3RlVGV4dFRyYWNrcygpLmFkZFRyYWNrXyhub2RlLnRyYWNrKTtcbiAgICAgICAgICAgIGlmICghY3Jvc3NvcmlnaW5UcmFja3MgJiZcbiAgICAgICAgICAgICAgICAhdGhpcy5lbF8uaGFzQXR0cmlidXRlKCdjcm9zc29yaWdpbicpICYmXG4gICAgICAgICAgICAgICAgVXJsLmlzQ3Jvc3NPcmlnaW4obm9kZS5zcmMpKSB7XG4gICAgICAgICAgICAgIGNyb3Nzb3JpZ2luVHJhY2tzID0gdHJ1ZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgZm9yIChsZXQgaT0wOyBpPHJlbW92ZU5vZGVzLmxlbmd0aDsgaSsrKSB7XG4gICAgICAgIHRoaXMuZWxfLnJlbW92ZUNoaWxkKHJlbW92ZU5vZGVzW2ldKTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICBsZXQgdHJhY2tUeXBlcyA9IFsnYXVkaW8nLCAndmlkZW8nXTtcblxuICAgIC8vIFByb3h5TmF0aXZlVGV4dFRyYWNrc1xuICAgIHRyYWNrVHlwZXMuZm9yRWFjaCgodHlwZSkgPT4ge1xuICAgICAgbGV0IGNhcGl0YWxUeXBlID0gdG9UaXRsZUNhc2UodHlwZSk7XG5cbiAgICAgIGlmICghdGhpc1tgZmVhdHVyZXNOYXRpdmUke2NhcGl0YWxUeXBlfVRyYWNrc2BdKSB7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cbiAgICAgIGxldCB0bCA9IHRoaXMuZWwoKVtgJHt0eXBlfVRyYWNrc2BdO1xuXG4gICAgICBpZiAodGwgJiYgdGwuYWRkRXZlbnRMaXN0ZW5lcikge1xuICAgICAgICB0bC5hZGRFdmVudExpc3RlbmVyKCdjaGFuZ2UnLCBGbi5iaW5kKHRoaXMsIHRoaXNbYGhhbmRsZSR7Y2FwaXRhbFR5cGV9VHJhY2tDaGFuZ2VfYF0pKTtcbiAgICAgICAgdGwuYWRkRXZlbnRMaXN0ZW5lcignYWRkdHJhY2snLCBGbi5iaW5kKHRoaXMsIHRoaXNbYGhhbmRsZSR7Y2FwaXRhbFR5cGV9VHJhY2tBZGRfYF0pKTtcbiAgICAgICAgdGwuYWRkRXZlbnRMaXN0ZW5lcigncmVtb3ZldHJhY2snLCBGbi5iaW5kKHRoaXMsIHRoaXNbYGhhbmRsZSR7Y2FwaXRhbFR5cGV9VHJhY2tSZW1vdmVfYF0pKTtcbiAgICAgIH1cbiAgICB9KTtcblxuICAgIGlmICh0aGlzLmZlYXR1cmVzTmF0aXZlVGV4dFRyYWNrcykge1xuICAgICAgaWYgKGNyb3Nzb3JpZ2luVHJhY2tzKSB7XG4gICAgICAgIGxvZy53YXJuKHRzbWxgVGV4dCBUcmFja3MgYXJlIGJlaW5nIGxvYWRlZCBmcm9tIGFub3RoZXIgb3JpZ2luIGJ1dCB0aGUgY3Jvc3NvcmlnaW4gYXR0cmlidXRlIGlzbid0IHVzZWQuIFxuICAgICAgICAgICAgVGhpcyBtYXkgcHJldmVudCB0ZXh0IHRyYWNrcyBmcm9tIGxvYWRpbmcuYCk7XG4gICAgICB9XG5cbiAgICAgIHRoaXMuaGFuZGxlVGV4dFRyYWNrQ2hhbmdlXyA9IEZuLmJpbmQodGhpcywgdGhpcy5oYW5kbGVUZXh0VHJhY2tDaGFuZ2UpO1xuICAgICAgdGhpcy5oYW5kbGVUZXh0VHJhY2tBZGRfID0gRm4uYmluZCh0aGlzLCB0aGlzLmhhbmRsZVRleHRUcmFja0FkZCk7XG4gICAgICB0aGlzLmhhbmRsZVRleHRUcmFja1JlbW92ZV8gPSBGbi5iaW5kKHRoaXMsIHRoaXMuaGFuZGxlVGV4dFRyYWNrUmVtb3ZlKTtcbiAgICAgIHRoaXMucHJveHlOYXRpdmVUZXh0VHJhY2tzXygpO1xuICAgIH1cblxuICAgIC8vIERldGVybWluZSBpZiBuYXRpdmUgY29udHJvbHMgc2hvdWxkIGJlIHVzZWRcbiAgICAvLyBPdXIgZ29hbCBzaG91bGQgYmUgdG8gZ2V0IHRoZSBjdXN0b20gY29udHJvbHMgb24gbW9iaWxlIHNvbGlkIGV2ZXJ5d2hlcmVcbiAgICAvLyBzbyB3ZSBjYW4gcmVtb3ZlIHRoaXMgYWxsIHRvZ2V0aGVyLiBSaWdodCBub3cgdGhpcyB3aWxsIGJsb2NrIGN1c3RvbVxuICAgIC8vIGNvbnRyb2xzIG9uIHRvdWNoIGVuYWJsZWQgbGFwdG9wcyBsaWtlIHRoZSBDaHJvbWUgUGl4ZWxcbiAgICBpZiAoYnJvd3Nlci5UT1VDSF9FTkFCTEVEICYmIG9wdGlvbnMubmF0aXZlQ29udHJvbHNGb3JUb3VjaCA9PT0gdHJ1ZSB8fFxuICAgICAgICBicm93c2VyLklTX0lQSE9ORSB8fFxuICAgICAgICBicm93c2VyLklTX05BVElWRV9BTkRST0lEKSB7XG4gICAgICB0aGlzLnNldENvbnRyb2xzKHRydWUpO1xuICAgIH1cblxuICAgIHRoaXMudHJpZ2dlclJlYWR5KCk7XG4gIH1cblxuICAvKipcbiAgICogRGlzcG9zZSBvZiBodG1sNSBtZWRpYSBlbGVtZW50XG4gICAqXG4gICAqIEBtZXRob2QgZGlzcG9zZVxuICAgKi9cbiAgZGlzcG9zZSgpIHtcbiAgICAvLyBVbi1Qcm94eU5hdGl2ZVRyYWNrc1xuICAgIFsnYXVkaW8nLCAndmlkZW8nLCAndGV4dCddLmZvckVhY2goKHR5cGUpID0+IHtcbiAgICAgIGxldCBjYXBpdGFsVHlwZSA9IHRvVGl0bGVDYXNlKHR5cGUpO1xuICAgICAgbGV0IHRsID0gdGhpcy5lbF9bYCR7dHlwZX1UcmFja3NgXTtcblxuICAgICAgaWYgKHRsICYmIHRsLnJlbW92ZUV2ZW50TGlzdGVuZXIpIHtcbiAgICAgICAgdGwucmVtb3ZlRXZlbnRMaXN0ZW5lcignY2hhbmdlJywgdGhpc1tgaGFuZGxlJHtjYXBpdGFsVHlwZX1UcmFja0NoYW5nZV9gXSk7XG4gICAgICAgIHRsLnJlbW92ZUV2ZW50TGlzdGVuZXIoJ2FkZHRyYWNrJywgdGhpc1tgaGFuZGxlJHtjYXBpdGFsVHlwZX1UcmFja0FkZF9gXSk7XG4gICAgICAgIHRsLnJlbW92ZUV2ZW50TGlzdGVuZXIoJ3JlbW92ZXRyYWNrJywgdGhpc1tgaGFuZGxlJHtjYXBpdGFsVHlwZX1UcmFja1JlbW92ZV9gXSk7XG4gICAgICB9XG4gICAgfSk7XG5cbiAgICBIdG1sNS5kaXNwb3NlTWVkaWFFbGVtZW50KHRoaXMuZWxfKTtcbiAgICAvLyB0ZWNoIHdpbGwgaGFuZGxlIGNsZWFyaW5nIG9mIHRoZSBlbXVsYXRlZCB0cmFjayBsaXN0XG4gICAgc3VwZXIuZGlzcG9zZSgpO1xuICB9XG5cbiAgLyoqXG4gICAqIENyZWF0ZSB0aGUgY29tcG9uZW50J3MgRE9NIGVsZW1lbnRcbiAgICpcbiAgICogQHJldHVybiB7RWxlbWVudH1cbiAgICogQG1ldGhvZCBjcmVhdGVFbFxuICAgKi9cbiAgY3JlYXRlRWwoKSB7XG4gICAgbGV0IGVsID0gdGhpcy5vcHRpb25zXy50YWc7XG5cbiAgICAvLyBDaGVjayBpZiB0aGlzIGJyb3dzZXIgc3VwcG9ydHMgbW92aW5nIHRoZSBlbGVtZW50IGludG8gdGhlIGJveC5cbiAgICAvLyBPbiB0aGUgaVBob25lIHZpZGVvIHdpbGwgYnJlYWsgaWYgeW91IG1vdmUgdGhlIGVsZW1lbnQsXG4gICAgLy8gU28gd2UgaGF2ZSB0byBjcmVhdGUgYSBicmFuZCBuZXcgZWxlbWVudC5cbiAgICBpZiAoIWVsIHx8IHRoaXNbJ21vdmluZ01lZGlhRWxlbWVudEluRE9NJ10gPT09IGZhbHNlKSB7XG5cbiAgICAgIC8vIElmIHRoZSBvcmlnaW5hbCB0YWcgaXMgc3RpbGwgdGhlcmUsIGNsb25lIGFuZCByZW1vdmUgaXQuXG4gICAgICBpZiAoZWwpIHtcbiAgICAgICAgY29uc3QgY2xvbmUgPSBlbC5jbG9uZU5vZGUodHJ1ZSk7XG4gICAgICAgIGVsLnBhcmVudE5vZGUuaW5zZXJ0QmVmb3JlKGNsb25lLCBlbCk7XG4gICAgICAgIEh0bWw1LmRpc3Bvc2VNZWRpYUVsZW1lbnQoZWwpO1xuICAgICAgICBlbCA9IGNsb25lO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgZWwgPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KCd2aWRlbycpO1xuXG4gICAgICAgIC8vIGRldGVybWluZSBpZiBuYXRpdmUgY29udHJvbHMgc2hvdWxkIGJlIHVzZWRcbiAgICAgICAgbGV0IHRhZ0F0dHJpYnV0ZXMgPSB0aGlzLm9wdGlvbnNfLnRhZyAmJiBEb20uZ2V0RWxBdHRyaWJ1dGVzKHRoaXMub3B0aW9uc18udGFnKTtcbiAgICAgICAgbGV0IGF0dHJpYnV0ZXMgPSBtZXJnZU9wdGlvbnMoe30sIHRhZ0F0dHJpYnV0ZXMpO1xuICAgICAgICBpZiAoIWJyb3dzZXIuVE9VQ0hfRU5BQkxFRCB8fCB0aGlzLm9wdGlvbnNfLm5hdGl2ZUNvbnRyb2xzRm9yVG91Y2ggIT09IHRydWUpIHtcbiAgICAgICAgICBkZWxldGUgYXR0cmlidXRlcy5jb250cm9scztcbiAgICAgICAgfVxuXG4gICAgICAgIERvbS5zZXRFbEF0dHJpYnV0ZXMoZWwsXG4gICAgICAgICAgYXNzaWduKGF0dHJpYnV0ZXMsIHtcbiAgICAgICAgICAgIGlkOiB0aGlzLm9wdGlvbnNfLnRlY2hJZCxcbiAgICAgICAgICAgIGNsYXNzOiAndmpzLXRlY2gnXG4gICAgICAgICAgfSlcbiAgICAgICAgKTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAvLyBVcGRhdGUgc3BlY2lmaWMgdGFnIHNldHRpbmdzLCBpbiBjYXNlIHRoZXkgd2VyZSBvdmVycmlkZGVuXG4gICAgbGV0IHNldHRpbmdzQXR0cnMgPSBbJ2F1dG9wbGF5JywncHJlbG9hZCcsJ2xvb3AnLCdtdXRlZCddO1xuICAgIGZvciAobGV0IGkgPSBzZXR0aW5nc0F0dHJzLmxlbmd0aCAtIDE7IGkgPj0gMDsgaS0tKSB7XG4gICAgICBjb25zdCBhdHRyID0gc2V0dGluZ3NBdHRyc1tpXTtcbiAgICAgIGxldCBvdmVyd3JpdGVBdHRycyA9IHt9O1xuICAgICAgaWYgKHR5cGVvZiB0aGlzLm9wdGlvbnNfW2F0dHJdICE9PSAndW5kZWZpbmVkJykge1xuICAgICAgICBvdmVyd3JpdGVBdHRyc1thdHRyXSA9IHRoaXMub3B0aW9uc19bYXR0cl07XG4gICAgICB9XG4gICAgICBEb20uc2V0RWxBdHRyaWJ1dGVzKGVsLCBvdmVyd3JpdGVBdHRycyk7XG4gICAgfVxuXG4gICAgcmV0dXJuIGVsO1xuICAgIC8vIGplbm5paXNhd2Vzb21lID0gdHJ1ZTtcbiAgfVxuXG4gIC8vIElmIHdlJ3JlIGxvYWRpbmcgdGhlIHBsYXliYWNrIG9iamVjdCBhZnRlciBpdCBoYXMgc3RhcnRlZCBsb2FkaW5nXG4gIC8vIG9yIHBsYXlpbmcgdGhlIHZpZGVvIChvZnRlbiB3aXRoIGF1dG9wbGF5IG9uKSB0aGVuIHRoZSBsb2Fkc3RhcnQgZXZlbnRcbiAgLy8gaGFzIGFscmVhZHkgZmlyZWQgYW5kIHdlIG5lZWQgdG8gZmlyZSBpdCBtYW51YWxseSBiZWNhdXNlIG1hbnkgdGhpbmdzXG4gIC8vIHJlbHkgb24gaXQuXG4gIGhhbmRsZUxhdGVJbml0XyhlbCkge1xuICAgIGlmIChlbC5uZXR3b3JrU3RhdGUgPT09IDAgfHwgZWwubmV0d29ya1N0YXRlID09PSAzKSB7XG4gICAgICAvLyBUaGUgdmlkZW8gZWxlbWVudCBoYXNuJ3Qgc3RhcnRlZCBsb2FkaW5nIHRoZSBzb3VyY2UgeWV0XG4gICAgICAvLyBvciBkaWRuJ3QgZmluZCBhIHNvdXJjZVxuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGlmIChlbC5yZWFkeVN0YXRlID09PSAwKSB7XG4gICAgICAvLyBOZXR3b3JrU3RhdGUgaXMgc2V0IHN5bmNocm9ub3VzbHkgQlVUIGxvYWRzdGFydCBpcyBmaXJlZCBhdCB0aGVcbiAgICAgIC8vIGVuZCBvZiB0aGUgY3VycmVudCBzdGFjaywgdXN1YWxseSBiZWZvcmUgc2V0SW50ZXJ2YWwoZm4sIDApLlxuICAgICAgLy8gU28gYXQgdGhpcyBwb2ludCB3ZSBrbm93IGxvYWRzdGFydCBtYXkgaGF2ZSBhbHJlYWR5IGZpcmVkIG9yIGlzXG4gICAgICAvLyBhYm91dCB0byBmaXJlLCBhbmQgZWl0aGVyIHdheSB0aGUgcGxheWVyIGhhc24ndCBzZWVuIGl0IHlldC5cbiAgICAgIC8vIFdlIGRvbid0IHdhbnQgdG8gZmlyZSBsb2Fkc3RhcnQgcHJlbWF0dXJlbHkgaGVyZSBhbmQgY2F1c2UgYVxuICAgICAgLy8gZG91YmxlIGxvYWRzdGFydCBzbyB3ZSdsbCB3YWl0IGFuZCBzZWUgaWYgaXQgaGFwcGVucyBiZXR3ZWVuIG5vd1xuICAgICAgLy8gYW5kIHRoZSBuZXh0IGxvb3AsIGFuZCBmaXJlIGl0IGlmIG5vdC5cbiAgICAgIC8vIEhPV0VWRVIsIHdlIGFsc28gd2FudCB0byBtYWtlIHN1cmUgaXQgZmlyZXMgYmVmb3JlIGxvYWRlZG1ldGFkYXRhXG4gICAgICAvLyB3aGljaCBjb3VsZCBhbHNvIGhhcHBlbiBiZXR3ZWVuIG5vdyBhbmQgdGhlIG5leHQgbG9vcCwgc28gd2UnbGxcbiAgICAgIC8vIHdhdGNoIGZvciB0aGF0IGFsc28uXG4gICAgICBsZXQgbG9hZHN0YXJ0RmlyZWQgPSBmYWxzZTtcbiAgICAgIGxldCBzZXRMb2Fkc3RhcnRGaXJlZCA9IGZ1bmN0aW9uKCkge1xuICAgICAgICBsb2Fkc3RhcnRGaXJlZCA9IHRydWU7XG4gICAgICB9O1xuICAgICAgdGhpcy5vbignbG9hZHN0YXJ0Jywgc2V0TG9hZHN0YXJ0RmlyZWQpO1xuXG4gICAgICBsZXQgdHJpZ2dlckxvYWRzdGFydCA9IGZ1bmN0aW9uKCkge1xuICAgICAgICAvLyBXZSBkaWQgbWlzcyB0aGUgb3JpZ2luYWwgbG9hZHN0YXJ0LiBNYWtlIHN1cmUgdGhlIHBsYXllclxuICAgICAgICAvLyBzZWVzIGxvYWRzdGFydCBiZWZvcmUgbG9hZGVkbWV0YWRhdGFcbiAgICAgICAgaWYgKCFsb2Fkc3RhcnRGaXJlZCkge1xuICAgICAgICAgIHRoaXMudHJpZ2dlcignbG9hZHN0YXJ0Jyk7XG4gICAgICAgIH1cbiAgICAgIH07XG4gICAgICB0aGlzLm9uKCdsb2FkZWRtZXRhZGF0YScsIHRyaWdnZXJMb2Fkc3RhcnQpO1xuXG4gICAgICB0aGlzLnJlYWR5KGZ1bmN0aW9uKCl7XG4gICAgICAgIHRoaXMub2ZmKCdsb2Fkc3RhcnQnLCBzZXRMb2Fkc3RhcnRGaXJlZCk7XG4gICAgICAgIHRoaXMub2ZmKCdsb2FkZWRtZXRhZGF0YScsIHRyaWdnZXJMb2Fkc3RhcnQpO1xuXG4gICAgICAgIGlmICghbG9hZHN0YXJ0RmlyZWQpIHtcbiAgICAgICAgICAvLyBXZSBkaWQgbWlzcyB0aGUgb3JpZ2luYWwgbmF0aXZlIGxvYWRzdGFydC4gRmlyZSBpdCBub3cuXG4gICAgICAgICAgdGhpcy50cmlnZ2VyKCdsb2Fkc3RhcnQnKTtcbiAgICAgICAgfVxuICAgICAgfSk7XG5cbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICAvLyBGcm9tIGhlcmUgb24gd2Uga25vdyB0aGF0IGxvYWRzdGFydCBhbHJlYWR5IGZpcmVkIGFuZCB3ZSBtaXNzZWQgaXQuXG4gICAgLy8gVGhlIG90aGVyIHJlYWR5U3RhdGUgZXZlbnRzIGFyZW4ndCBhcyBtdWNoIG9mIGEgcHJvYmxlbSBpZiB3ZSBkb3VibGVcbiAgICAvLyB0aGVtLCBzbyBub3QgZ29pbmcgdG8gZ28gdG8gYXMgbXVjaCB0cm91YmxlIGFzIGxvYWRzdGFydCB0byBwcmV2ZW50XG4gICAgLy8gdGhhdCB1bmxlc3Mgd2UgZmluZCByZWFzb24gdG8uXG4gICAgbGV0IGV2ZW50c1RvVHJpZ2dlciA9IFsnbG9hZHN0YXJ0J107XG5cbiAgICAvLyBsb2FkZWRtZXRhZGF0YTogbmV3bHkgZXF1YWwgdG8gSEFWRV9NRVRBREFUQSAoMSkgb3IgZ3JlYXRlclxuICAgIGV2ZW50c1RvVHJpZ2dlci5wdXNoKCdsb2FkZWRtZXRhZGF0YScpO1xuXG4gICAgLy8gbG9hZGVkZGF0YTogbmV3bHkgaW5jcmVhc2VkIHRvIEhBVkVfQ1VSUkVOVF9EQVRBICgyKSBvciBncmVhdGVyXG4gICAgaWYgKGVsLnJlYWR5U3RhdGUgPj0gMikge1xuICAgICAgZXZlbnRzVG9UcmlnZ2VyLnB1c2goJ2xvYWRlZGRhdGEnKTtcbiAgICB9XG5cbiAgICAvLyBjYW5wbGF5OiBuZXdseSBpbmNyZWFzZWQgdG8gSEFWRV9GVVRVUkVfREFUQSAoMykgb3IgZ3JlYXRlclxuICAgIGlmIChlbC5yZWFkeVN0YXRlID49IDMpIHtcbiAgICAgIGV2ZW50c1RvVHJpZ2dlci5wdXNoKCdjYW5wbGF5Jyk7XG4gICAgfVxuXG4gICAgLy8gY2FucGxheXRocm91Z2g6IG5ld2x5IGVxdWFsIHRvIEhBVkVfRU5PVUdIX0RBVEEgKDQpXG4gICAgaWYgKGVsLnJlYWR5U3RhdGUgPj0gNCkge1xuICAgICAgZXZlbnRzVG9UcmlnZ2VyLnB1c2goJ2NhbnBsYXl0aHJvdWdoJyk7XG4gICAgfVxuXG4gICAgLy8gV2Ugc3RpbGwgbmVlZCB0byBnaXZlIHRoZSBwbGF5ZXIgdGltZSB0byBhZGQgZXZlbnQgbGlzdGVuZXJzXG4gICAgdGhpcy5yZWFkeShmdW5jdGlvbigpe1xuICAgICAgZXZlbnRzVG9UcmlnZ2VyLmZvckVhY2goZnVuY3Rpb24odHlwZSl7XG4gICAgICAgIHRoaXMudHJpZ2dlcih0eXBlKTtcbiAgICAgIH0sIHRoaXMpO1xuICAgIH0pO1xuICB9XG5cbiAgcHJveHlOYXRpdmVUZXh0VHJhY2tzXygpIHtcbiAgICBsZXQgdHQgPSB0aGlzLmVsKCkudGV4dFRyYWNrcztcblxuICAgIGlmICh0dCkge1xuICAgICAgLy8gQWRkIHRyYWNrcyAtIGlmIHBsYXllciBpcyBpbml0aWFsaXNlZCBhZnRlciBET00gbG9hZGVkLCB0ZXh0VHJhY2tzXG4gICAgICAvLyB3aWxsIG5vdCB0cmlnZ2VyIGFkZHRyYWNrXG4gICAgICBmb3IgKGxldCBpID0gMDsgaSA8IHR0Lmxlbmd0aDsgaSsrKSB7XG4gICAgICAgIHRoaXMudGV4dFRyYWNrcygpLmFkZFRyYWNrXyh0dFtpXSk7XG4gICAgICB9XG5cbiAgICAgIGlmICh0dC5hZGRFdmVudExpc3RlbmVyKSB7XG4gICAgICAgIHR0LmFkZEV2ZW50TGlzdGVuZXIoJ2NoYW5nZScsIHRoaXMuaGFuZGxlVGV4dFRyYWNrQ2hhbmdlXyk7XG4gICAgICAgIHR0LmFkZEV2ZW50TGlzdGVuZXIoJ2FkZHRyYWNrJywgdGhpcy5oYW5kbGVUZXh0VHJhY2tBZGRfKTtcbiAgICAgICAgdHQuYWRkRXZlbnRMaXN0ZW5lcigncmVtb3ZldHJhY2snLCB0aGlzLmhhbmRsZVRleHRUcmFja1JlbW92ZV8pO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIGhhbmRsZVRleHRUcmFja0NoYW5nZShlKSB7XG4gICAgbGV0IHR0ID0gdGhpcy50ZXh0VHJhY2tzKCk7XG4gICAgdGhpcy50ZXh0VHJhY2tzKCkudHJpZ2dlcih7XG4gICAgICB0eXBlOiAnY2hhbmdlJyxcbiAgICAgIHRhcmdldDogdHQsXG4gICAgICBjdXJyZW50VGFyZ2V0OiB0dCxcbiAgICAgIHNyY0VsZW1lbnQ6IHR0XG4gICAgfSk7XG4gIH1cblxuICBoYW5kbGVUZXh0VHJhY2tBZGQoZSkge1xuICAgIHRoaXMudGV4dFRyYWNrcygpLmFkZFRyYWNrXyhlLnRyYWNrKTtcbiAgfVxuXG4gIGhhbmRsZVRleHRUcmFja1JlbW92ZShlKSB7XG4gICAgdGhpcy50ZXh0VHJhY2tzKCkucmVtb3ZlVHJhY2tfKGUudHJhY2spO1xuICB9XG5cbiAgaGFuZGxlVmlkZW9UcmFja0NoYW5nZV8oZSkge1xuICAgIGxldCB2dCA9IHRoaXMudmlkZW9UcmFja3MoKTtcbiAgICB0aGlzLnZpZGVvVHJhY2tzKCkudHJpZ2dlcih7XG4gICAgICB0eXBlOiAnY2hhbmdlJyxcbiAgICAgIHRhcmdldDogdnQsXG4gICAgICBjdXJyZW50VGFyZ2V0OiB2dCxcbiAgICAgIHNyY0VsZW1lbnQ6IHZ0XG4gICAgfSk7XG4gIH1cblxuICBoYW5kbGVWaWRlb1RyYWNrQWRkXyhlKSB7XG4gICAgdGhpcy52aWRlb1RyYWNrcygpLmFkZFRyYWNrXyhlLnRyYWNrKTtcbiAgfVxuXG4gIGhhbmRsZVZpZGVvVHJhY2tSZW1vdmVfKGUpIHtcbiAgICB0aGlzLnZpZGVvVHJhY2tzKCkucmVtb3ZlVHJhY2tfKGUudHJhY2spO1xuICB9XG5cbiAgaGFuZGxlQXVkaW9UcmFja0NoYW5nZV8oZSkge1xuICAgIGxldCBhdWRpb1RyYWNrTGlzdCA9IHRoaXMuYXVkaW9UcmFja3MoKTtcbiAgICB0aGlzLmF1ZGlvVHJhY2tzKCkudHJpZ2dlcih7XG4gICAgICB0eXBlOiAnY2hhbmdlJyxcbiAgICAgIHRhcmdldDogYXVkaW9UcmFja0xpc3QsXG4gICAgICBjdXJyZW50VGFyZ2V0OiBhdWRpb1RyYWNrTGlzdCxcbiAgICAgIHNyY0VsZW1lbnQ6IGF1ZGlvVHJhY2tMaXN0XG4gICAgfSk7XG4gIH1cblxuICBoYW5kbGVBdWRpb1RyYWNrQWRkXyhlKSB7XG4gICAgdGhpcy5hdWRpb1RyYWNrcygpLmFkZFRyYWNrXyhlLnRyYWNrKTtcbiAgfVxuXG4gIGhhbmRsZUF1ZGlvVHJhY2tSZW1vdmVfKGUpIHtcbiAgICB0aGlzLmF1ZGlvVHJhY2tzKCkucmVtb3ZlVHJhY2tfKGUudHJhY2spO1xuICB9XG5cblxuICAvKipcbiAgICogUGxheSBmb3IgaHRtbDUgdGVjaFxuICAgKlxuICAgKiBAbWV0aG9kIHBsYXlcbiAgICovXG4gIHBsYXkoKSB7XG4gICAgICB2YXIgcHJvbWlzZSA9IHRoaXMuZWxfLnBsYXkoKTtcbiAgICAgIGlmIChwcm9taXNlKSAvLyBzdXBwcmVzcyB1bmNhdWdodCBET01FeGNlcHRpb25cbiAgICAgICAgICBwcm9taXNlLmNhdGNoKGZ1bmN0aW9uKCl7fSk7XG4gIH1cblxuICAvKipcbiAgICogUGF1c2UgZm9yIGh0bWw1IHRlY2hcbiAgICpcbiAgICogQG1ldGhvZCBwYXVzZVxuICAgKi9cbiAgcGF1c2UoKSB7IHRoaXMuZWxfLnBhdXNlKCk7IH1cblxuICAvKipcbiAgICogUGF1c2VkIGZvciBodG1sNSB0ZWNoXG4gICAqXG4gICAqIEByZXR1cm4ge0Jvb2xlYW59XG4gICAqIEBtZXRob2QgcGF1c2VkXG4gICAqL1xuICBwYXVzZWQoKSB7IHJldHVybiB0aGlzLmVsXy5wYXVzZWQ7IH1cblxuICAvKipcbiAgICogR2V0IGN1cnJlbnQgdGltZVxuICAgKlxuICAgKiBAcmV0dXJuIHtOdW1iZXJ9XG4gICAqIEBtZXRob2QgY3VycmVudFRpbWVcbiAgICovXG4gIGN1cnJlbnRUaW1lKCkgeyByZXR1cm4gdGhpcy5lbF8uY3VycmVudFRpbWU7IH1cblxuICAvKipcbiAgICogU2V0IGN1cnJlbnQgdGltZVxuICAgKlxuICAgKiBAcGFyYW0ge051bWJlcn0gc2Vjb25kcyBDdXJyZW50IHRpbWUgb2YgdmlkZW9cbiAgICogQG1ldGhvZCBzZXRDdXJyZW50VGltZVxuICAgKi9cbiAgc2V0Q3VycmVudFRpbWUoc2Vjb25kcykge1xuICAgIHRyeSB7XG4gICAgICB0aGlzLmVsXy5jdXJyZW50VGltZSA9IHNlY29uZHM7XG4gICAgfSBjYXRjaChlKSB7XG4gICAgICBsb2coZSwgJ1ZpZGVvIGlzIG5vdCByZWFkeS4gKFZpZGVvLmpzKScpO1xuICAgICAgLy8gdGhpcy53YXJuaW5nKFZpZGVvSlMud2FybmluZ3MudmlkZW9Ob3RSZWFkeSk7XG4gICAgfVxuICB9XG5cbiAgLyoqXG4gICAqIEdldCBkdXJhdGlvblxuICAgKlxuICAgKiBAcmV0dXJuIHtOdW1iZXJ9XG4gICAqIEBtZXRob2QgZHVyYXRpb25cbiAgICovXG4gIGR1cmF0aW9uKCkgeyByZXR1cm4gdGhpcy5lbF8uZHVyYXRpb24gfHwgMDsgfVxuXG4gIC8qKlxuICAgKiBHZXQgYSBUaW1lUmFuZ2Ugb2JqZWN0IHRoYXQgcmVwcmVzZW50cyB0aGUgaW50ZXJzZWN0aW9uXG4gICAqIG9mIHRoZSB0aW1lIHJhbmdlcyBmb3Igd2hpY2ggdGhlIHVzZXIgYWdlbnQgaGFzIGFsbFxuICAgKiByZWxldmFudCBtZWRpYVxuICAgKlxuICAgKiBAcmV0dXJuIHtUaW1lUmFuZ2VPYmplY3R9XG4gICAqIEBtZXRob2QgYnVmZmVyZWRcbiAgICovXG4gIGJ1ZmZlcmVkKCkgeyByZXR1cm4gdGhpcy5lbF8uYnVmZmVyZWQ7IH1cblxuICAvKipcbiAgICogR2V0IHZvbHVtZSBsZXZlbFxuICAgKlxuICAgKiBAcmV0dXJuIHtOdW1iZXJ9XG4gICAqIEBtZXRob2Qgdm9sdW1lXG4gICAqL1xuICB2b2x1bWUoKSB7IHJldHVybiB0aGlzLmVsXy52b2x1bWU7IH1cblxuICAvKipcbiAgICogU2V0IHZvbHVtZSBsZXZlbFxuICAgKlxuICAgKiBAcGFyYW0ge051bWJlcn0gcGVyY2VudEFzRGVjaW1hbCBWb2x1bWUgcGVyY2VudCBhcyBhIGRlY2ltYWxcbiAgICogQG1ldGhvZCBzZXRWb2x1bWVcbiAgICovXG4gIHNldFZvbHVtZShwZXJjZW50QXNEZWNpbWFsKSB7IHRoaXMuZWxfLnZvbHVtZSA9IHBlcmNlbnRBc0RlY2ltYWw7IH1cblxuICAvKipcbiAgICogR2V0IGlmIG11dGVkXG4gICAqXG4gICAqIEByZXR1cm4ge0Jvb2xlYW59XG4gICAqIEBtZXRob2QgbXV0ZWRcbiAgICovXG4gIG11dGVkKCkgeyByZXR1cm4gdGhpcy5lbF8ubXV0ZWQ7IH1cblxuICAvKipcbiAgICogU2V0IG11dGVkXG4gICAqXG4gICAqIEBwYXJhbSB7Qm9vbGVhbn0gSWYgcGxheWVyIGlzIHRvIGJlIG11dGVkIG9yIG5vdGVcbiAgICogQG1ldGhvZCBzZXRNdXRlZFxuICAgKi9cbiAgc2V0TXV0ZWQobXV0ZWQpIHsgdGhpcy5lbF8ubXV0ZWQgPSBtdXRlZDsgfVxuXG4gIC8qKlxuICAgKiBHZXQgcGxheWVyIHdpZHRoXG4gICAqXG4gICAqIEByZXR1cm4ge051bWJlcn1cbiAgICogQG1ldGhvZCB3aWR0aFxuICAgKi9cbiAgd2lkdGgoKSB7IHJldHVybiB0aGlzLmVsXy5vZmZzZXRXaWR0aDsgfVxuXG4gIC8qKlxuICAgKiBHZXQgcGxheWVyIGhlaWdodFxuICAgKlxuICAgKiBAcmV0dXJuIHtOdW1iZXJ9XG4gICAqIEBtZXRob2QgaGVpZ2h0XG4gICAqL1xuICBoZWlnaHQoKSB7ICByZXR1cm4gdGhpcy5lbF8ub2Zmc2V0SGVpZ2h0OyB9XG5cbiAgLyoqXG4gICAqIEdldCBpZiB0aGVyZSBpcyBmdWxsc2NyZWVuIHN1cHBvcnRcbiAgICpcbiAgICogQHJldHVybiB7Qm9vbGVhbn1cbiAgICogQG1ldGhvZCBzdXBwb3J0c0Z1bGxTY3JlZW5cbiAgICovXG4gIHN1cHBvcnRzRnVsbFNjcmVlbigpIHtcbiAgICBpZiAodHlwZW9mIHRoaXMuZWxfLndlYmtpdEVudGVyRnVsbFNjcmVlbiA9PT0gJ2Z1bmN0aW9uJykge1xuICAgICAgbGV0IHVzZXJBZ2VudCA9IHdpbmRvdy5uYXZpZ2F0b3IudXNlckFnZW50O1xuICAgICAgLy8gU2VlbXMgdG8gYmUgYnJva2VuIGluIENocm9taXVtL0Nocm9tZSAmJiBTYWZhcmkgaW4gTGVvcGFyZFxuICAgICAgaWYgKC9BbmRyb2lkLy50ZXN0KHVzZXJBZ2VudCkgfHwgIS9DaHJvbWV8TWFjIE9TIFggMTAuNS8udGVzdCh1c2VyQWdlbnQpKSB7XG4gICAgICAgIHJldHVybiB0cnVlO1xuICAgICAgfVxuICAgIH1cbiAgICByZXR1cm4gZmFsc2U7XG4gIH1cblxuICAvKipcbiAgICogUmVxdWVzdCB0byBlbnRlciBmdWxsc2NyZWVuXG4gICAqXG4gICAqIEBtZXRob2QgZW50ZXJGdWxsU2NyZWVuXG4gICAqL1xuICBlbnRlckZ1bGxTY3JlZW4oKSB7XG4gICAgdmFyIHZpZGVvID0gdGhpcy5lbF87XG5cbiAgICBpZiAoJ3dlYmtpdERpc3BsYXlpbmdGdWxsc2NyZWVuJyBpbiB2aWRlbykge1xuICAgICAgdGhpcy5vbmUoJ3dlYmtpdGJlZ2luZnVsbHNjcmVlbicsIGZ1bmN0aW9uKCkge1xuICAgICAgICB0aGlzLm9uZSgnd2Via2l0ZW5kZnVsbHNjcmVlbicsIGZ1bmN0aW9uKCkge1xuICAgICAgICAgIHRoaXMudHJpZ2dlcignZnVsbHNjcmVlbmNoYW5nZScsIHsgaXNGdWxsc2NyZWVuOiBmYWxzZSB9KTtcbiAgICAgICAgfSk7XG5cbiAgICAgICAgdGhpcy50cmlnZ2VyKCdmdWxsc2NyZWVuY2hhbmdlJywgeyBpc0Z1bGxzY3JlZW46IHRydWUgfSk7XG4gICAgICB9KTtcbiAgICB9XG5cbiAgICBpZiAodmlkZW8ucGF1c2VkICYmIHZpZGVvLm5ldHdvcmtTdGF0ZSA8PSB2aWRlby5IQVZFX01FVEFEQVRBKSB7XG4gICAgICAvLyBhdHRlbXB0IHRvIHByaW1lIHRoZSB2aWRlbyBlbGVtZW50IGZvciBwcm9ncmFtbWF0aWMgYWNjZXNzXG4gICAgICAvLyB0aGlzIGlzbid0IG5lY2Vzc2FyeSBvbiB0aGUgZGVza3RvcCBidXQgc2hvdWxkbid0IGh1cnRcbiAgICAgICAgdGhpcy5wbGF5KCk7XG5cbiAgICAgIC8vIHBsYXlpbmcgYW5kIHBhdXNpbmcgc3luY2hyb25vdXNseSBkdXJpbmcgdGhlIHRyYW5zaXRpb24gdG8gZnVsbHNjcmVlblxuICAgICAgLy8gY2FuIGdldCBpT1MgfjYuMSBkZXZpY2VzIGludG8gYSBwbGF5L3BhdXNlIGxvb3BcbiAgICAgIHRoaXMuc2V0VGltZW91dChmdW5jdGlvbigpe1xuICAgICAgICB2aWRlby5wYXVzZSgpO1xuICAgICAgICB2aWRlby53ZWJraXRFbnRlckZ1bGxTY3JlZW4oKTtcbiAgICAgIH0sIDApO1xuICAgIH0gZWxzZSB7XG4gICAgICB2aWRlby53ZWJraXRFbnRlckZ1bGxTY3JlZW4oKTtcbiAgICB9XG4gIH1cblxuICAvKipcbiAgICogUmVxdWVzdCB0byBleGl0IGZ1bGxzY3JlZW5cbiAgICpcbiAgICogQG1ldGhvZCBleGl0RnVsbFNjcmVlblxuICAgKi9cbiAgZXhpdEZ1bGxTY3JlZW4oKSB7XG4gICAgdGhpcy5lbF8ud2Via2l0RXhpdEZ1bGxTY3JlZW4oKTtcbiAgfVxuXG4gIC8qKlxuICAgKiBHZXQvc2V0IHZpZGVvXG4gICAqXG4gICAqIEBwYXJhbSB7T2JqZWN0PX0gc3JjIFNvdXJjZSBvYmplY3RcbiAgICogQHJldHVybiB7T2JqZWN0fVxuICAgKiBAbWV0aG9kIHNyY1xuICAgKi9cbiAgc3JjKHNyYykge1xuICAgIGlmIChzcmMgPT09IHVuZGVmaW5lZCkge1xuICAgICAgcmV0dXJuIHRoaXMuZWxfLnNyYztcbiAgICB9IGVsc2Uge1xuICAgICAgLy8gU2V0dGluZyBzcmMgdGhyb3VnaCBgc3JjYCBpbnN0ZWFkIG9mIGBzZXRTcmNgIHdpbGwgYmUgZGVwcmVjYXRlZFxuICAgICAgdGhpcy5zZXRTcmMoc3JjKTtcbiAgICB9XG4gIH1cblxuICAvKipcbiAgICogU2V0IHZpZGVvXG4gICAqXG4gICAqIEBwYXJhbSB7T2JqZWN0fSBzcmMgU291cmNlIG9iamVjdFxuICAgKiBAZGVwcmVjYXRlZFxuICAgKiBAbWV0aG9kIHNldFNyY1xuICAgKi9cbiAgc2V0U3JjKHNyYykge1xuICAgIHRoaXMuZWxfLnNyYyA9IHNyYztcbiAgfVxuXG4gIC8qKlxuICAgKiBMb2FkIG1lZGlhIGludG8gcGxheWVyXG4gICAqXG4gICAqIEBtZXRob2QgbG9hZFxuICAgKi9cbiAgbG9hZCgpe1xuICAgIHRoaXMuZWxfLmxvYWQoKTtcbiAgfVxuXG4gIC8qKlxuICAgKiBSZXNldCB0aGUgdGVjaC4gUmVtb3ZlcyBhbGwgc291cmNlcyBhbmQgY2FsbHMgYGxvYWRgLlxuICAgKlxuICAgKiBAbWV0aG9kIHJlc2V0XG4gICAqL1xuICByZXNldCgpIHtcbiAgICBIdG1sNS5yZXNldE1lZGlhRWxlbWVudCh0aGlzLmVsXyk7XG4gIH1cblxuICAvKipcbiAgICogR2V0IGN1cnJlbnQgc291cmNlXG4gICAqXG4gICAqIEByZXR1cm4ge09iamVjdH1cbiAgICogQG1ldGhvZCBjdXJyZW50U3JjXG4gICAqL1xuICBjdXJyZW50U3JjKCkge1xuICAgIGlmICh0aGlzLmN1cnJlbnRTb3VyY2VfKSB7XG4gICAgICByZXR1cm4gdGhpcy5jdXJyZW50U291cmNlXy5zcmM7XG4gICAgfSBlbHNlIHtcbiAgICAgIHJldHVybiB0aGlzLmVsXy5jdXJyZW50U3JjO1xuICAgIH1cbiAgfVxuXG4gIC8qKlxuICAgKiBHZXQgcG9zdGVyXG4gICAqXG4gICAqIEByZXR1cm4ge1N0cmluZ31cbiAgICogQG1ldGhvZCBwb3N0ZXJcbiAgICovXG4gIHBvc3RlcigpIHsgcmV0dXJuIHRoaXMuZWxfLnBvc3RlcjsgfVxuXG4gIC8qKlxuICAgKiBTZXQgcG9zdGVyXG4gICAqXG4gICAqIEBwYXJhbSB7U3RyaW5nfSB2YWwgVVJMIHRvIHBvc3RlciBpbWFnZVxuICAgKiBAbWV0aG9kXG4gICAqL1xuICBzZXRQb3N0ZXIodmFsKSB7IHRoaXMuZWxfLnBvc3RlciA9IHZhbDsgfVxuXG4gIC8qKlxuICAgKiBHZXQgcHJlbG9hZCBhdHRyaWJ1dGVcbiAgICpcbiAgICogQHJldHVybiB7U3RyaW5nfVxuICAgKiBAbWV0aG9kIHByZWxvYWRcbiAgICovXG4gIHByZWxvYWQoKSB7IHJldHVybiB0aGlzLmVsXy5wcmVsb2FkOyB9XG5cbiAgLyoqXG4gICAqIFNldCBwcmVsb2FkIGF0dHJpYnV0ZVxuICAgKlxuICAgKiBAcGFyYW0ge1N0cmluZ30gdmFsIFZhbHVlIGZvciBwcmVsb2FkIGF0dHJpYnV0ZVxuICAgKiBAbWV0aG9kIHNldFByZWxvYWRcbiAgICovXG4gIHNldFByZWxvYWQodmFsKSB7IHRoaXMuZWxfLnByZWxvYWQgPSB2YWw7IH1cblxuICAvKipcbiAgICogR2V0IGF1dG9wbGF5IGF0dHJpYnV0ZVxuICAgKlxuICAgKiBAcmV0dXJuIHtTdHJpbmd9XG4gICAqIEBtZXRob2QgYXV0b3BsYXlcbiAgICovXG4gIGF1dG9wbGF5KCkgeyByZXR1cm4gdGhpcy5lbF8uYXV0b3BsYXk7IH1cblxuICAvKipcbiAgICogU2V0IGF1dG9wbGF5IGF0dHJpYnV0ZVxuICAgKlxuICAgKiBAcGFyYW0ge1N0cmluZ30gdmFsIFZhbHVlIGZvciBwcmVsb2FkIGF0dHJpYnV0ZVxuICAgKiBAbWV0aG9kIHNldEF1dG9wbGF5XG4gICAqL1xuICBzZXRBdXRvcGxheSh2YWwpIHsgdGhpcy5lbF8uYXV0b3BsYXkgPSB2YWw7IH1cblxuICAvKipcbiAgICogR2V0IGNvbnRyb2xzIGF0dHJpYnV0ZVxuICAgKlxuICAgKiBAcmV0dXJuIHtTdHJpbmd9XG4gICAqIEBtZXRob2QgY29udHJvbHNcbiAgICovXG4gIGNvbnRyb2xzKCkgeyByZXR1cm4gdGhpcy5lbF8uY29udHJvbHM7IH1cblxuICAvKipcbiAgICogU2V0IGNvbnRyb2xzIGF0dHJpYnV0ZVxuICAgKlxuICAgKiBAcGFyYW0ge1N0cmluZ30gdmFsIFZhbHVlIGZvciBjb250cm9scyBhdHRyaWJ1dGVcbiAgICogQG1ldGhvZCBzZXRDb250cm9sc1xuICAgKi9cbiAgc2V0Q29udHJvbHModmFsKSB7IHRoaXMuZWxfLmNvbnRyb2xzID0gISF2YWw7IH1cblxuICAvKipcbiAgICogR2V0IGxvb3AgYXR0cmlidXRlXG4gICAqXG4gICAqIEByZXR1cm4ge1N0cmluZ31cbiAgICogQG1ldGhvZCBsb29wXG4gICAqL1xuICBsb29wKCkgeyByZXR1cm4gdGhpcy5lbF8ubG9vcDsgfVxuXG4gIC8qKlxuICAgKiBTZXQgbG9vcCBhdHRyaWJ1dGVcbiAgICpcbiAgICogQHBhcmFtIHtTdHJpbmd9IHZhbCBWYWx1ZSBmb3IgbG9vcCBhdHRyaWJ1dGVcbiAgICogQG1ldGhvZCBzZXRMb29wXG4gICAqL1xuICBzZXRMb29wKHZhbCkgeyB0aGlzLmVsXy5sb29wID0gdmFsOyB9XG5cbiAgLyoqXG4gICAqIEdldCBlcnJvciB2YWx1ZVxuICAgKlxuICAgKiBAcmV0dXJuIHtTdHJpbmd9XG4gICAqIEBtZXRob2QgZXJyb3JcbiAgICovXG4gIGVycm9yKCkgeyByZXR1cm4gdGhpcy5lbF8uZXJyb3I7IH1cblxuICAvKipcbiAgICogR2V0IHdoZXRoZXIgb3Igbm90IHRoZSBwbGF5ZXIgaXMgaW4gdGhlIFwic2Vla2luZ1wiIHN0YXRlXG4gICAqXG4gICAqIEByZXR1cm4ge0Jvb2xlYW59XG4gICAqIEBtZXRob2Qgc2Vla2luZ1xuICAgKi9cbiAgc2Vla2luZygpIHsgcmV0dXJuIHRoaXMuZWxfLnNlZWtpbmc7IH1cblxuICAvKipcbiAgICogR2V0IGEgVGltZVJhbmdlcyBvYmplY3QgdGhhdCByZXByZXNlbnRzIHRoZVxuICAgKiByYW5nZXMgb2YgdGhlIG1lZGlhIHJlc291cmNlIHRvIHdoaWNoIGl0IGlzIHBvc3NpYmxlXG4gICAqIGZvciB0aGUgdXNlciBhZ2VudCB0byBzZWVrLlxuICAgKlxuICAgKiBAcmV0dXJuIHtUaW1lUmFuZ2VPYmplY3R9XG4gICAqIEBtZXRob2Qgc2Vla2FibGVcbiAgICovXG4gIHNlZWthYmxlKCkgeyByZXR1cm4gdGhpcy5lbF8uc2Vla2FibGU7IH1cblxuICAvKipcbiAgICogR2V0IGlmIHZpZGVvIGVuZGVkXG4gICAqXG4gICAqIEByZXR1cm4ge0Jvb2xlYW59XG4gICAqIEBtZXRob2QgZW5kZWRcbiAgICovXG4gIGVuZGVkKCkgeyByZXR1cm4gdGhpcy5lbF8uZW5kZWQ7IH1cblxuICAvKipcbiAgICogR2V0IHRoZSB2YWx1ZSBvZiB0aGUgbXV0ZWQgY29udGVudCBhdHRyaWJ1dGVcbiAgICogVGhpcyBhdHRyaWJ1dGUgaGFzIG5vIGR5bmFtaWMgZWZmZWN0LCBpdCBvbmx5XG4gICAqIGNvbnRyb2xzIHRoZSBkZWZhdWx0IHN0YXRlIG9mIHRoZSBlbGVtZW50XG4gICAqXG4gICAqIEByZXR1cm4ge0Jvb2xlYW59XG4gICAqIEBtZXRob2QgZGVmYXVsdE11dGVkXG4gICAqL1xuICBkZWZhdWx0TXV0ZWQoKSB7IHJldHVybiB0aGlzLmVsXy5kZWZhdWx0TXV0ZWQ7IH1cblxuICAvKipcbiAgICogR2V0IGRlc2lyZWQgc3BlZWQgYXQgd2hpY2ggdGhlIG1lZGlhIHJlc291cmNlIGlzIHRvIHBsYXlcbiAgICpcbiAgICogQHJldHVybiB7TnVtYmVyfVxuICAgKiBAbWV0aG9kIHBsYXliYWNrUmF0ZVxuICAgKi9cbiAgcGxheWJhY2tSYXRlKCkgeyByZXR1cm4gdGhpcy5lbF8ucGxheWJhY2tSYXRlOyB9XG5cbiAgLyoqXG4gICAqIFJldHVybnMgYSBUaW1lUmFuZ2VzIG9iamVjdCB0aGF0IHJlcHJlc2VudHMgdGhlIHJhbmdlcyBvZiB0aGVcbiAgICogbWVkaWEgcmVzb3VyY2UgdGhhdCB0aGUgdXNlciBhZ2VudCBoYXMgcGxheWVkLlxuICAgKiBAcmV0dXJuIHtUaW1lUmFuZ2VPYmplY3R9IHRoZSByYW5nZSBvZiBwb2ludHMgb24gdGhlIG1lZGlhXG4gICAqIHRpbWVsaW5lIHRoYXQgaGFzIGJlZW4gcmVhY2hlZCB0aHJvdWdoIG5vcm1hbCBwbGF5YmFja1xuICAgKiBAc2VlIGh0dHBzOi8vaHRtbC5zcGVjLndoYXR3Zy5vcmcvbXVsdGlwYWdlL2VtYmVkZGVkLWNvbnRlbnQuaHRtbCNkb20tbWVkaWEtcGxheWVkXG4gICAqL1xuICBwbGF5ZWQoKSB7IHJldHVybiB0aGlzLmVsXy5wbGF5ZWQ7IH1cblxuICAvKipcbiAgICogU2V0IGRlc2lyZWQgc3BlZWQgYXQgd2hpY2ggdGhlIG1lZGlhIHJlc291cmNlIGlzIHRvIHBsYXlcbiAgICpcbiAgICogQHBhcmFtIHtOdW1iZXJ9IHZhbCBTcGVlZCBhdCB3aGljaCB0aGUgbWVkaWEgcmVzb3VyY2UgaXMgdG8gcGxheVxuICAgKiBAbWV0aG9kIHNldFBsYXliYWNrUmF0ZVxuICAgKi9cbiAgc2V0UGxheWJhY2tSYXRlKHZhbCkgeyB0aGlzLmVsXy5wbGF5YmFja1JhdGUgPSB2YWw7IH1cblxuICAvKipcbiAgICogR2V0IHRoZSBjdXJyZW50IHN0YXRlIG9mIG5ldHdvcmsgYWN0aXZpdHkgZm9yIHRoZSBlbGVtZW50LCBmcm9tXG4gICAqIHRoZSBsaXN0IGJlbG93XG4gICAqIE5FVFdPUktfRU1QVFkgKG51bWVyaWMgdmFsdWUgMClcbiAgICogTkVUV09SS19JRExFIChudW1lcmljIHZhbHVlIDEpXG4gICAqIE5FVFdPUktfTE9BRElORyAobnVtZXJpYyB2YWx1ZSAyKVxuICAgKiBORVRXT1JLX05PX1NPVVJDRSAobnVtZXJpYyB2YWx1ZSAzKVxuICAgKlxuICAgKiBAcmV0dXJuIHtOdW1iZXJ9XG4gICAqIEBtZXRob2QgbmV0d29ya1N0YXRlXG4gICAqL1xuICBuZXR3b3JrU3RhdGUoKSB7IHJldHVybiB0aGlzLmVsXy5uZXR3b3JrU3RhdGU7IH1cblxuICAvKipcbiAgICogR2V0IGEgdmFsdWUgdGhhdCBleHByZXNzZXMgdGhlIGN1cnJlbnQgc3RhdGUgb2YgdGhlIGVsZW1lbnRcbiAgICogd2l0aCByZXNwZWN0IHRvIHJlbmRlcmluZyB0aGUgY3VycmVudCBwbGF5YmFjayBwb3NpdGlvbiwgZnJvbVxuICAgKiB0aGUgY29kZXMgaW4gdGhlIGxpc3QgYmVsb3dcbiAgICogSEFWRV9OT1RISU5HIChudW1lcmljIHZhbHVlIDApXG4gICAqIEhBVkVfTUVUQURBVEEgKG51bWVyaWMgdmFsdWUgMSlcbiAgICogSEFWRV9DVVJSRU5UX0RBVEEgKG51bWVyaWMgdmFsdWUgMilcbiAgICogSEFWRV9GVVRVUkVfREFUQSAobnVtZXJpYyB2YWx1ZSAzKVxuICAgKiBIQVZFX0VOT1VHSF9EQVRBIChudW1lcmljIHZhbHVlIDQpXG4gICAqXG4gICAqIEByZXR1cm4ge051bWJlcn1cbiAgICogQG1ldGhvZCByZWFkeVN0YXRlXG4gICAqL1xuICByZWFkeVN0YXRlKCkgeyByZXR1cm4gdGhpcy5lbF8ucmVhZHlTdGF0ZTsgfVxuXG4gIC8qKlxuICAgKiBHZXQgd2lkdGggb2YgdmlkZW9cbiAgICpcbiAgICogQHJldHVybiB7TnVtYmVyfVxuICAgKiBAbWV0aG9kIHZpZGVvV2lkdGhcbiAgICovXG4gIHZpZGVvV2lkdGgoKSB7IHJldHVybiB0aGlzLmVsXy52aWRlb1dpZHRoOyB9XG5cbiAgLyoqXG4gICAqIEdldCBoZWlnaHQgb2YgdmlkZW9cbiAgICpcbiAgICogQHJldHVybiB7TnVtYmVyfVxuICAgKiBAbWV0aG9kIHZpZGVvSGVpZ2h0XG4gICAqL1xuICB2aWRlb0hlaWdodCgpIHsgcmV0dXJuIHRoaXMuZWxfLnZpZGVvSGVpZ2h0OyB9XG5cbiAgLyoqXG4gICAqIEdldCB0ZXh0IHRyYWNrc1xuICAgKlxuICAgKiBAcmV0dXJuIHtUZXh0VHJhY2tMaXN0fVxuICAgKiBAbWV0aG9kIHRleHRUcmFja3NcbiAgICovXG4gIHRleHRUcmFja3MoKSB7XG4gICAgcmV0dXJuIHN1cGVyLnRleHRUcmFja3MoKTtcbiAgfVxuXG4gIC8qKlxuICAgKiBDcmVhdGVzIGFuZCByZXR1cm5zIGEgdGV4dCB0cmFjayBvYmplY3RcbiAgICpcbiAgICogQHBhcmFtIHtTdHJpbmd9IGtpbmQgVGV4dCB0cmFjayBraW5kIChzdWJ0aXRsZXMsIGNhcHRpb25zLCBkZXNjcmlwdGlvbnNcbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjaGFwdGVycyBhbmQgbWV0YWRhdGEpXG4gICAqIEBwYXJhbSB7U3RyaW5nPX0gbGFiZWwgTGFiZWwgdG8gaWRlbnRpZnkgdGhlIHRleHQgdHJhY2tcbiAgICogQHBhcmFtIHtTdHJpbmc9fSBsYW5ndWFnZSBUd28gbGV0dGVyIGxhbmd1YWdlIGFiYnJldmlhdGlvblxuICAgKiBAcmV0dXJuIHtUZXh0VHJhY2tPYmplY3R9XG4gICAqIEBtZXRob2QgYWRkVGV4dFRyYWNrXG4gICAqL1xuICBhZGRUZXh0VHJhY2soa2luZCwgbGFiZWwsIGxhbmd1YWdlKSB7XG4gICAgaWYgKCF0aGlzWydmZWF0dXJlc05hdGl2ZVRleHRUcmFja3MnXSkge1xuICAgICAgcmV0dXJuIHN1cGVyLmFkZFRleHRUcmFjayhraW5kLCBsYWJlbCwgbGFuZ3VhZ2UpO1xuICAgIH1cblxuICAgIHJldHVybiB0aGlzLmVsXy5hZGRUZXh0VHJhY2soa2luZCwgbGFiZWwsIGxhbmd1YWdlKTtcbiAgfVxuXG4gIC8qKlxuICAgKiBDcmVhdGVzIGEgcmVtb3RlIHRleHQgdHJhY2sgb2JqZWN0IGFuZCByZXR1cm5zIGEgaHRtbCB0cmFjayBlbGVtZW50XG4gICAqXG4gICAqIEBwYXJhbSB7T2JqZWN0fSBvcHRpb25zIFRoZSBvYmplY3Qgc2hvdWxkIGNvbnRhaW4gdmFsdWVzIGZvclxuICAgKiBraW5kLCBsYW5ndWFnZSwgbGFiZWwgYW5kIHNyYyAobG9jYXRpb24gb2YgdGhlIFdlYlZUVCBmaWxlKVxuICAgKiBAcmV0dXJuIHtIVE1MVHJhY2tFbGVtZW50fVxuICAgKiBAbWV0aG9kIGFkZFJlbW90ZVRleHRUcmFja1xuICAgKi9cbiAgYWRkUmVtb3RlVGV4dFRyYWNrKG9wdGlvbnM9e30pIHtcbiAgICBpZiAoIXRoaXNbJ2ZlYXR1cmVzTmF0aXZlVGV4dFRyYWNrcyddKSB7XG4gICAgICByZXR1cm4gc3VwZXIuYWRkUmVtb3RlVGV4dFRyYWNrKG9wdGlvbnMpO1xuICAgIH1cblxuICAgIGxldCBodG1sVHJhY2tFbGVtZW50ID0gZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgndHJhY2snKTtcblxuICAgIGlmIChvcHRpb25zLmtpbmQpIHtcbiAgICAgIGh0bWxUcmFja0VsZW1lbnQua2luZCA9IG9wdGlvbnMua2luZDtcbiAgICB9XG4gICAgaWYgKG9wdGlvbnMubGFiZWwpIHtcbiAgICAgIGh0bWxUcmFja0VsZW1lbnQubGFiZWwgPSBvcHRpb25zLmxhYmVsO1xuICAgIH1cbiAgICBpZiAob3B0aW9ucy5sYW5ndWFnZSB8fCBvcHRpb25zLnNyY2xhbmcpIHtcbiAgICAgIGh0bWxUcmFja0VsZW1lbnQuc3JjbGFuZyA9IG9wdGlvbnMubGFuZ3VhZ2UgfHwgb3B0aW9ucy5zcmNsYW5nO1xuICAgIH1cbiAgICBpZiAob3B0aW9ucy5kZWZhdWx0KSB7XG4gICAgICBodG1sVHJhY2tFbGVtZW50LmRlZmF1bHQgPSBvcHRpb25zLmRlZmF1bHQ7XG4gICAgfVxuICAgIGlmIChvcHRpb25zLmlkKSB7XG4gICAgICBodG1sVHJhY2tFbGVtZW50LmlkID0gb3B0aW9ucy5pZDtcbiAgICB9XG4gICAgaWYgKG9wdGlvbnMuc3JjKSB7XG4gICAgICBodG1sVHJhY2tFbGVtZW50LnNyYyA9IG9wdGlvbnMuc3JjO1xuICAgIH1cblxuICAgIHRoaXMuZWwoKS5hcHBlbmRDaGlsZChodG1sVHJhY2tFbGVtZW50KTtcblxuICAgIC8vIHN0b3JlIEhUTUxUcmFja0VsZW1lbnQgYW5kIFRleHRUcmFjayB0byByZW1vdGUgbGlzdFxuICAgIHRoaXMucmVtb3RlVGV4dFRyYWNrRWxzKCkuYWRkVHJhY2tFbGVtZW50XyhodG1sVHJhY2tFbGVtZW50KTtcbiAgICB0aGlzLnJlbW90ZVRleHRUcmFja3MoKS5hZGRUcmFja18oaHRtbFRyYWNrRWxlbWVudC50cmFjayk7XG5cbiAgICByZXR1cm4gaHRtbFRyYWNrRWxlbWVudDtcbiAgfVxuXG4gIC8qKlxuICAgKiBSZW1vdmUgcmVtb3RlIHRleHQgdHJhY2sgZnJvbSBUZXh0VHJhY2tMaXN0IG9iamVjdFxuICAgKlxuICAgKiBAcGFyYW0ge1RleHRUcmFja09iamVjdH0gdHJhY2sgVGV4dHRyYWNrIG9iamVjdCB0byByZW1vdmVcbiAgICogQG1ldGhvZCByZW1vdmVSZW1vdGVUZXh0VHJhY2tcbiAgICovXG4gIHJlbW92ZVJlbW90ZVRleHRUcmFjayh0cmFjaykge1xuICAgIGlmICghdGhpc1snZmVhdHVyZXNOYXRpdmVUZXh0VHJhY2tzJ10pIHtcbiAgICAgIHJldHVybiBzdXBlci5yZW1vdmVSZW1vdGVUZXh0VHJhY2sodHJhY2spO1xuICAgIH1cblxuICAgIGxldCB0cmFja3MsIGk7XG5cbiAgICBsZXQgdHJhY2tFbGVtZW50ID0gdGhpcy5yZW1vdGVUZXh0VHJhY2tFbHMoKS5nZXRUcmFja0VsZW1lbnRCeVRyYWNrXyh0cmFjayk7XG5cbiAgICAvLyByZW1vdmUgSFRNTFRyYWNrRWxlbWVudCBhbmQgVGV4dFRyYWNrIGZyb20gcmVtb3RlIGxpc3RcbiAgICB0aGlzLnJlbW90ZVRleHRUcmFja0VscygpLnJlbW92ZVRyYWNrRWxlbWVudF8odHJhY2tFbGVtZW50KTtcbiAgICB0aGlzLnJlbW90ZVRleHRUcmFja3MoKS5yZW1vdmVUcmFja18odHJhY2spO1xuXG4gICAgdHJhY2tzID0gdGhpcy4kJCgndHJhY2snKTtcblxuICAgIGkgPSB0cmFja3MubGVuZ3RoO1xuICAgIHdoaWxlIChpLS0pIHtcbiAgICAgIGlmICh0cmFjayA9PT0gdHJhY2tzW2ldIHx8IHRyYWNrID09PSB0cmFja3NbaV0udHJhY2spIHtcbiAgICAgICAgdGhpcy5lbCgpLnJlbW92ZUNoaWxkKHRyYWNrc1tpXSk7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbn1cblxuXG4vKiBIVE1MNSBTdXBwb3J0IFRlc3RpbmcgLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAqL1xuXG4vKlxuKiBFbGVtZW50IGZvciB0ZXN0aW5nIGJyb3dzZXIgSFRNTDUgdmlkZW8gY2FwYWJpbGl0aWVzXG4qXG4qIEB0eXBlIHtFbGVtZW50fVxuKiBAY29uc3RhbnRcbiogQHByaXZhdGVcbiovXG5IdG1sNS5URVNUX1ZJRCA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ3ZpZGVvJyk7XG5sZXQgdHJhY2sgPSBkb2N1bWVudC5jcmVhdGVFbGVtZW50KCd0cmFjaycpO1xudHJhY2sua2luZCA9ICdjYXB0aW9ucyc7XG50cmFjay5zcmNsYW5nID0gJ2VuJztcbnRyYWNrLmxhYmVsID0gJ0VuZ2xpc2gnO1xuSHRtbDUuVEVTVF9WSUQuYXBwZW5kQ2hpbGQodHJhY2spO1xuXG4vKlxuICogQ2hlY2sgaWYgSFRNTDUgdmlkZW8gaXMgc3VwcG9ydGVkIGJ5IHRoaXMgYnJvd3Nlci9kZXZpY2VcbiAqXG4gKiBAcmV0dXJuIHtCb29sZWFufVxuICovXG5IdG1sNS5pc1N1cHBvcnRlZCA9IGZ1bmN0aW9uKCl7XG4gIC8vIElFOSB3aXRoIG5vIE1lZGlhIFBsYXllciBpcyBhIExJQVIhICgjOTg0KVxuICB0cnkge1xuICAgIEh0bWw1LlRFU1RfVklEWyd2b2x1bWUnXSA9IDAuNTtcbiAgfSBjYXRjaCAoZSkge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuXG4gIHJldHVybiAhIUh0bWw1LlRFU1RfVklELmNhblBsYXlUeXBlO1xufTtcblxuLy8gQWRkIFNvdXJjZSBIYW5kbGVyIHBhdHRlcm4gZnVuY3Rpb25zIHRvIHRoaXMgdGVjaFxuVGVjaC53aXRoU291cmNlSGFuZGxlcnMoSHRtbDUpO1xuXG4vKlxuICogVGhlIGRlZmF1bHQgbmF0aXZlIHNvdXJjZSBoYW5kbGVyLlxuICogVGhpcyBzaW1wbHkgcGFzc2VzIHRoZSBzb3VyY2UgdG8gdGhlIHZpZGVvIGVsZW1lbnQuIE5vdGhpbmcgZmFuY3kuXG4gKlxuICogQHBhcmFtICB7T2JqZWN0fSBzb3VyY2UgICBUaGUgc291cmNlIG9iamVjdFxuICogQHBhcmFtICB7SHRtbDV9IHRlY2ggIFRoZSBpbnN0YW5jZSBvZiB0aGUgSFRNTDUgdGVjaFxuICovXG5IdG1sNS5uYXRpdmVTb3VyY2VIYW5kbGVyID0ge307XG5cbi8qXG4gKiBDaGVjayBpZiB0aGUgdmlkZW8gZWxlbWVudCBjYW4gcGxheSB0aGUgZ2l2ZW4gdmlkZW90eXBlXG4gKlxuICogQHBhcmFtICB7U3RyaW5nfSB0eXBlICAgIFRoZSBtaW1ldHlwZSB0byBjaGVja1xuICogQHJldHVybiB7U3RyaW5nfSAgICAgICAgICdwcm9iYWJseScsICdtYXliZScsIG9yICcnIChlbXB0eSBzdHJpbmcpXG4gKi9cbkh0bWw1Lm5hdGl2ZVNvdXJjZUhhbmRsZXIuY2FuUGxheVR5cGUgPSBmdW5jdGlvbih0eXBlKXtcbiAgLy8gSUU5IG9uIFdpbmRvd3MgNyB3aXRob3V0IE1lZGlhUGxheWVyIHRocm93cyBhbiBlcnJvciBoZXJlXG4gIC8vIGh0dHBzOi8vZ2l0aHViLmNvbS92aWRlb2pzL3ZpZGVvLmpzL2lzc3Vlcy81MTlcbiAgdHJ5IHtcbiAgICByZXR1cm4gSHRtbDUuVEVTVF9WSUQuY2FuUGxheVR5cGUodHlwZSk7XG4gIH0gY2F0Y2goZSkge1xuICAgIHJldHVybiAnJztcbiAgfVxufTtcblxuLypcbiAqIENoZWNrIGlmIHRoZSB2aWRlbyBlbGVtZW50IGNhbiBoYW5kbGUgdGhlIHNvdXJjZSBuYXRpdmVseVxuICpcbiAqIEBwYXJhbSAge09iamVjdH0gc291cmNlICBUaGUgc291cmNlIG9iamVjdFxuICogQHJldHVybiB7U3RyaW5nfSAgICAgICAgICdwcm9iYWJseScsICdtYXliZScsIG9yICcnIChlbXB0eSBzdHJpbmcpXG4gKi9cbkh0bWw1Lm5hdGl2ZVNvdXJjZUhhbmRsZXIuY2FuSGFuZGxlU291cmNlID0gZnVuY3Rpb24oc291cmNlKXtcbiAgdmFyIG1hdGNoLCBleHQ7XG5cbiAgLy8gSWYgYSB0eXBlIHdhcyBwcm92aWRlZCB3ZSBzaG91bGQgcmVseSBvbiB0aGF0XG4gIGlmIChzb3VyY2UudHlwZSkge1xuICAgIHJldHVybiBIdG1sNS5uYXRpdmVTb3VyY2VIYW5kbGVyLmNhblBsYXlUeXBlKHNvdXJjZS50eXBlKTtcbiAgfSBlbHNlIGlmIChzb3VyY2Uuc3JjKSB7XG4gICAgLy8gSWYgbm8gdHlwZSwgZmFsbCBiYWNrIHRvIGNoZWNraW5nICd2aWRlby9bRVhURU5TSU9OXSdcbiAgICBleHQgPSBVcmwuZ2V0RmlsZUV4dGVuc2lvbihzb3VyY2Uuc3JjKTtcblxuICAgIHJldHVybiBIdG1sNS5uYXRpdmVTb3VyY2VIYW5kbGVyLmNhblBsYXlUeXBlKGB2aWRlby8ke2V4dH1gKTtcbiAgfVxuXG4gIHJldHVybiAnJztcbn07XG5cbi8qXG4gKiBQYXNzIHRoZSBzb3VyY2UgdG8gdGhlIHZpZGVvIGVsZW1lbnRcbiAqIEFkYXB0aXZlIHNvdXJjZSBoYW5kbGVycyB3aWxsIGhhdmUgbW9yZSBjb21wbGljYXRlZCB3b3JrZmxvd3MgYmVmb3JlIHBhc3NpbmdcbiAqIHZpZGVvIGRhdGEgdG8gdGhlIHZpZGVvIGVsZW1lbnRcbiAqXG4gKiBAcGFyYW0gIHtPYmplY3R9IHNvdXJjZSAgIFRoZSBzb3VyY2Ugb2JqZWN0XG4gKiBAcGFyYW0gIHtIdG1sNX0gIHRlY2ggICAgIFRoZSBpbnN0YW5jZSBvZiB0aGUgSHRtbDUgdGVjaFxuICogQHBhcmFtICB7T2JqZWN0fSBvcHRpb25zICBUaGUgb3B0aW9ucyB0byBwYXNzIHRvIHRoZSBzb3VyY2VcbiAqL1xuSHRtbDUubmF0aXZlU291cmNlSGFuZGxlci5oYW5kbGVTb3VyY2UgPSBmdW5jdGlvbihzb3VyY2UsIHRlY2gsIG9wdGlvbnMpe1xuICB0ZWNoLnNldFNyYyhzb3VyY2Uuc3JjKTtcbn07XG5cbi8qXG4qIENsZWFuIHVwIHRoZSBzb3VyY2UgaGFuZGxlciB3aGVuIGRpc3Bvc2luZyB0aGUgcGxheWVyIG9yIHN3aXRjaGluZyBzb3VyY2VzLi5cbiogKG5vIGNsZWFudXAgaXMgbmVlZGVkIHdoZW4gc3VwcG9ydGluZyB0aGUgZm9ybWF0IG5hdGl2ZWx5KVxuKi9cbkh0bWw1Lm5hdGl2ZVNvdXJjZUhhbmRsZXIuZGlzcG9zZSA9IGZ1bmN0aW9uKCl7fTtcblxuLy8gUmVnaXN0ZXIgdGhlIG5hdGl2ZSBzb3VyY2UgaGFuZGxlclxuSHRtbDUucmVnaXN0ZXJTb3VyY2VIYW5kbGVyKEh0bWw1Lm5hdGl2ZVNvdXJjZUhhbmRsZXIpO1xuXG4vKlxuICogQ2hlY2sgaWYgdGhlIHZvbHVtZSBjYW4gYmUgY2hhbmdlZCBpbiB0aGlzIGJyb3dzZXIvZGV2aWNlLlxuICogVm9sdW1lIGNhbm5vdCBiZSBjaGFuZ2VkIGluIGEgbG90IG9mIG1vYmlsZSBkZXZpY2VzLlxuICogU3BlY2lmaWNhbGx5LCBpdCBjYW4ndCBiZSBjaGFuZ2VkIGZyb20gMSBvbiBpT1MuXG4gKlxuICogQHJldHVybiB7Qm9vbGVhbn1cbiAqL1xuSHRtbDUuY2FuQ29udHJvbFZvbHVtZSA9IGZ1bmN0aW9uKCl7XG4gIHZhciB2b2x1bWUgPSAgSHRtbDUuVEVTVF9WSUQudm9sdW1lO1xuICBIdG1sNS5URVNUX1ZJRC52b2x1bWUgPSAodm9sdW1lIC8gMikgKyAwLjE7XG4gIHJldHVybiB2b2x1bWUgIT09IEh0bWw1LlRFU1RfVklELnZvbHVtZTtcbn07XG5cbi8qXG4gKiBDaGVjayBpZiBwbGF5YmFja1JhdGUgaXMgc3VwcG9ydGVkIGluIHRoaXMgYnJvd3Nlci9kZXZpY2UuXG4gKlxuICogQHJldHVybiB7Qm9vbGVhbn1cbiAqL1xuSHRtbDUuY2FuQ29udHJvbFBsYXliYWNrUmF0ZSA9IGZ1bmN0aW9uKCl7XG4gIC8vIFBsYXliYWNrIHJhdGUgQVBJIGlzIGltcGxlbWVudGVkIGluIEFuZHJvaWQgQ2hyb21lLCBidXQgZG9lc24ndCBkbyBhbnl0aGluZ1xuICAvLyBodHRwczovL2dpdGh1Yi5jb20vdmlkZW9qcy92aWRlby5qcy9pc3N1ZXMvMzE4MFxuICBpZiAoYnJvd3Nlci5JU19BTkRST0lEICYmIGJyb3dzZXIuSVNfQ0hST01FKSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG4gIHZhciBwbGF5YmFja1JhdGUgPSBIdG1sNS5URVNUX1ZJRC5wbGF5YmFja1JhdGU7XG4gIEh0bWw1LlRFU1RfVklELnBsYXliYWNrUmF0ZSA9IChwbGF5YmFja1JhdGUgLyAyKSArIDAuMTtcbiAgcmV0dXJuIHBsYXliYWNrUmF0ZSAhPT0gSHRtbDUuVEVTVF9WSUQucGxheWJhY2tSYXRlO1xufTtcblxuLypcbiAqIENoZWNrIHRvIHNlZSBpZiBuYXRpdmUgdGV4dCB0cmFja3MgYXJlIHN1cHBvcnRlZCBieSB0aGlzIGJyb3dzZXIvZGV2aWNlXG4gKlxuICogQHJldHVybiB7Qm9vbGVhbn1cbiAqL1xuSHRtbDUuc3VwcG9ydHNOYXRpdmVUZXh0VHJhY2tzID0gZnVuY3Rpb24oKSB7XG4gIHZhciBzdXBwb3J0c1RleHRUcmFja3M7XG5cbiAgLy8gRmlndXJlIG91dCBuYXRpdmUgdGV4dCB0cmFjayBzdXBwb3J0XG4gIC8vIElmIG1vZGUgaXMgYSBudW1iZXIsIHdlIGNhbm5vdCBjaGFuZ2UgaXQgYmVjYXVzZSBpdCdsbCBkaXNhcHBlYXIgZnJvbSB2aWV3LlxuICAvLyBCcm93c2VycyB3aXRoIG51bWVyaWMgbW9kZXMgaW5jbHVkZSBJRTEwIGFuZCBvbGRlciAoPD0yMDEzKSBzYW1zdW5nIGFuZHJvaWQgbW9kZWxzLlxuICAvLyBGaXJlZm94IGlzbid0IHBsYXlpbmcgbmljZSBlaXRoZXIgd2l0aCBtb2RpZnlpbmcgdGhlIG1vZGVcbiAgLy8gVE9ETzogSW52ZXN0aWdhdGUgZmlyZWZveDogaHR0cHM6Ly9naXRodWIuY29tL3ZpZGVvanMvdmlkZW8uanMvaXNzdWVzLzE4NjJcbiAgc3VwcG9ydHNUZXh0VHJhY2tzID0gISFIdG1sNS5URVNUX1ZJRC50ZXh0VHJhY2tzO1xuICBpZiAoc3VwcG9ydHNUZXh0VHJhY2tzICYmIEh0bWw1LlRFU1RfVklELnRleHRUcmFja3MubGVuZ3RoID4gMCkge1xuICAgIHN1cHBvcnRzVGV4dFRyYWNrcyA9IHR5cGVvZiBIdG1sNS5URVNUX1ZJRC50ZXh0VHJhY2tzWzBdWydtb2RlJ10gIT09ICdudW1iZXInO1xuICB9XG4gIGlmIChzdXBwb3J0c1RleHRUcmFja3MgJiYgYnJvd3Nlci5JU19GSVJFRk9YKSB7XG4gICAgc3VwcG9ydHNUZXh0VHJhY2tzID0gZmFsc2U7XG4gIH1cbiAgaWYgKHN1cHBvcnRzVGV4dFRyYWNrcyAmJiAhKCdvbnJlbW92ZXRyYWNrJyBpbiBIdG1sNS5URVNUX1ZJRC50ZXh0VHJhY2tzKSkge1xuICAgIHN1cHBvcnRzVGV4dFRyYWNrcyA9IGZhbHNlO1xuICB9XG5cbiAgcmV0dXJuIHN1cHBvcnRzVGV4dFRyYWNrcztcbn07XG5cbi8qXG4gKiBDaGVjayB0byBzZWUgaWYgbmF0aXZlIHZpZGVvIHRyYWNrcyBhcmUgc3VwcG9ydGVkIGJ5IHRoaXMgYnJvd3Nlci9kZXZpY2VcbiAqXG4gKiBAcmV0dXJuIHtCb29sZWFufVxuICovXG5IdG1sNS5zdXBwb3J0c05hdGl2ZVZpZGVvVHJhY2tzID0gZnVuY3Rpb24oKSB7XG4gIGxldCBzdXBwb3J0c1ZpZGVvVHJhY2tzID0gISFIdG1sNS5URVNUX1ZJRC52aWRlb1RyYWNrcztcbiAgcmV0dXJuIHN1cHBvcnRzVmlkZW9UcmFja3M7XG59O1xuXG4vKlxuICogQ2hlY2sgdG8gc2VlIGlmIG5hdGl2ZSBhdWRpbyB0cmFja3MgYXJlIHN1cHBvcnRlZCBieSB0aGlzIGJyb3dzZXIvZGV2aWNlXG4gKlxuICogQHJldHVybiB7Qm9vbGVhbn1cbiAqL1xuSHRtbDUuc3VwcG9ydHNOYXRpdmVBdWRpb1RyYWNrcyA9IGZ1bmN0aW9uKCkge1xuICBsZXQgc3VwcG9ydHNBdWRpb1RyYWNrcyA9ICEhSHRtbDUuVEVTVF9WSUQuYXVkaW9UcmFja3M7XG4gIHJldHVybiBzdXBwb3J0c0F1ZGlvVHJhY2tzO1xufTtcblxuXG4vKipcbiAqIEFuIGFycmF5IG9mIGV2ZW50cyBhdmFpbGFibGUgb24gdGhlIEh0bWw1IHRlY2guXG4gKlxuICogQHByaXZhdGVcbiAqIEB0eXBlIHtBcnJheX1cbiAqL1xuSHRtbDUuRXZlbnRzID0gW1xuICAnbG9hZHN0YXJ0JyxcbiAgJ3N1c3BlbmQnLFxuICAnYWJvcnQnLFxuICAnZXJyb3InLFxuICAnZW1wdGllZCcsXG4gICdzdGFsbGVkJyxcbiAgJ2xvYWRlZG1ldGFkYXRhJyxcbiAgJ2xvYWRlZGRhdGEnLFxuICAnY2FucGxheScsXG4gICdjYW5wbGF5dGhyb3VnaCcsXG4gICdwbGF5aW5nJyxcbiAgJ3dhaXRpbmcnLFxuICAnc2Vla2luZycsXG4gICdzZWVrZWQnLFxuICAnZW5kZWQnLFxuICAnZHVyYXRpb25jaGFuZ2UnLFxuICAndGltZXVwZGF0ZScsXG4gICdwcm9ncmVzcycsXG4gICdwbGF5JyxcbiAgJ3BhdXNlJyxcbiAgJ3JhdGVjaGFuZ2UnLFxuICAndm9sdW1lY2hhbmdlJ1xuXTtcblxuLypcbiAqIFNldCB0aGUgdGVjaCdzIHZvbHVtZSBjb250cm9sIHN1cHBvcnQgc3RhdHVzXG4gKlxuICogQHR5cGUge0Jvb2xlYW59XG4gKi9cbkh0bWw1LnByb3RvdHlwZVsnZmVhdHVyZXNWb2x1bWVDb250cm9sJ10gPSBIdG1sNS5jYW5Db250cm9sVm9sdW1lKCk7XG5cbi8qXG4gKiBTZXQgdGhlIHRlY2gncyBwbGF5YmFja1JhdGUgc3VwcG9ydCBzdGF0dXNcbiAqXG4gKiBAdHlwZSB7Qm9vbGVhbn1cbiAqL1xuSHRtbDUucHJvdG90eXBlWydmZWF0dXJlc1BsYXliYWNrUmF0ZSddID0gSHRtbDUuY2FuQ29udHJvbFBsYXliYWNrUmF0ZSgpO1xuXG4vKlxuICogU2V0IHRoZSB0ZWNoJ3Mgc3RhdHVzIG9uIG1vdmluZyB0aGUgdmlkZW8gZWxlbWVudC5cbiAqIEluIGlPUywgaWYgeW91IG1vdmUgYSB2aWRlbyBlbGVtZW50IGluIHRoZSBET00sIGl0IGJyZWFrcyB2aWRlbyBwbGF5YmFjay5cbiAqXG4gKiBAdHlwZSB7Qm9vbGVhbn1cbiAqL1xuSHRtbDUucHJvdG90eXBlWydtb3ZpbmdNZWRpYUVsZW1lbnRJbkRPTSddID0gIWJyb3dzZXIuSVNfSU9TO1xuXG4vKlxuICogU2V0IHRoZSB0aGUgdGVjaCdzIGZ1bGxzY3JlZW4gcmVzaXplIHN1cHBvcnQgc3RhdHVzLlxuICogSFRNTCB2aWRlbyBpcyBhYmxlIHRvIGF1dG9tYXRpY2FsbHkgcmVzaXplIHdoZW4gZ29pbmcgdG8gZnVsbHNjcmVlbi5cbiAqIChObyBsb25nZXIgYXBwZWFycyB0byBiZSB1c2VkLiBDYW4gcHJvYmFibHkgYmUgcmVtb3ZlZC4pXG4gKi9cbkh0bWw1LnByb3RvdHlwZVsnZmVhdHVyZXNGdWxsc2NyZWVuUmVzaXplJ10gPSB0cnVlO1xuXG4vKlxuICogU2V0IHRoZSB0ZWNoJ3MgcHJvZ3Jlc3MgZXZlbnQgc3VwcG9ydCBzdGF0dXNcbiAqICh0aGlzIGRpc2FibGVzIHRoZSBtYW51YWwgcHJvZ3Jlc3MgZXZlbnRzIG9mIHRoZSBUZWNoKVxuICovXG5IdG1sNS5wcm90b3R5cGVbJ2ZlYXR1cmVzUHJvZ3Jlc3NFdmVudHMnXSA9IHRydWU7XG5cbi8qXG4gKiBTZXRzIHRoZSB0ZWNoJ3Mgc3RhdHVzIG9uIG5hdGl2ZSB0ZXh0IHRyYWNrIHN1cHBvcnRcbiAqXG4gKiBAdHlwZSB7Qm9vbGVhbn1cbiAqL1xuSHRtbDUucHJvdG90eXBlWydmZWF0dXJlc05hdGl2ZVRleHRUcmFja3MnXSA9IEh0bWw1LnN1cHBvcnRzTmF0aXZlVGV4dFRyYWNrcygpO1xuXG4vKipcbiAqIFNldHMgdGhlIHRlY2gncyBzdGF0dXMgb24gbmF0aXZlIHRleHQgdHJhY2sgc3VwcG9ydFxuICpcbiAqIEB0eXBlIHtCb29sZWFufVxuICovXG5IdG1sNS5wcm90b3R5cGVbJ2ZlYXR1cmVzTmF0aXZlVmlkZW9UcmFja3MnXSA9IEh0bWw1LnN1cHBvcnRzTmF0aXZlVmlkZW9UcmFja3MoKTtcblxuLyoqXG4gKiBTZXRzIHRoZSB0ZWNoJ3Mgc3RhdHVzIG9uIG5hdGl2ZSBhdWRpbyB0cmFjayBzdXBwb3J0XG4gKlxuICogQHR5cGUge0Jvb2xlYW59XG4gKi9cbkh0bWw1LnByb3RvdHlwZVsnZmVhdHVyZXNOYXRpdmVBdWRpb1RyYWNrcyddID0gSHRtbDUuc3VwcG9ydHNOYXRpdmVBdWRpb1RyYWNrcygpO1xuXG4vLyBIVE1MNSBGZWF0dXJlIGRldGVjdGlvbiBhbmQgRGV2aWNlIEZpeGVzIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSAvL1xubGV0IGNhblBsYXlUeXBlO1xuY29uc3QgbXBlZ3VybFJFID0gL15hcHBsaWNhdGlvblxcLyg/OngtfHZuZFxcLmFwcGxlXFwuKW1wZWd1cmwvaTtcbmNvbnN0IG1wNFJFID0gL152aWRlb1xcL21wNC9pO1xuXG5IdG1sNS5wYXRjaENhblBsYXlUeXBlID0gZnVuY3Rpb24oKSB7XG4gIC8vIEFuZHJvaWQgNC4wIGFuZCBhYm92ZSBjYW4gcGxheSBITFMgdG8gc29tZSBleHRlbnQgYnV0IGl0IHJlcG9ydHMgYmVpbmcgdW5hYmxlIHRvIGRvIHNvXG4gIGlmIChicm93c2VyLkFORFJPSURfVkVSU0lPTiA+PSA0LjApIHtcbiAgICBpZiAoIWNhblBsYXlUeXBlKSB7XG4gICAgICBjYW5QbGF5VHlwZSA9IEh0bWw1LlRFU1RfVklELmNvbnN0cnVjdG9yLnByb3RvdHlwZS5jYW5QbGF5VHlwZTtcbiAgICB9XG5cbiAgICBIdG1sNS5URVNUX1ZJRC5jb25zdHJ1Y3Rvci5wcm90b3R5cGUuY2FuUGxheVR5cGUgPSBmdW5jdGlvbih0eXBlKSB7XG4gICAgICBpZiAodHlwZSAmJiBtcGVndXJsUkUudGVzdCh0eXBlKSkge1xuICAgICAgICByZXR1cm4gJ21heWJlJztcbiAgICAgIH1cbiAgICAgIHJldHVybiBjYW5QbGF5VHlwZS5jYWxsKHRoaXMsIHR5cGUpO1xuICAgIH07XG4gIH1cblxuICAvLyBPdmVycmlkZSBBbmRyb2lkIDIuMiBhbmQgbGVzcyBjYW5QbGF5VHlwZSBtZXRob2Qgd2hpY2ggaXMgYnJva2VuXG4gIGlmIChicm93c2VyLklTX09MRF9BTkRST0lEKSB7XG4gICAgaWYgKCFjYW5QbGF5VHlwZSkge1xuICAgICAgY2FuUGxheVR5cGUgPSBIdG1sNS5URVNUX1ZJRC5jb25zdHJ1Y3Rvci5wcm90b3R5cGUuY2FuUGxheVR5cGU7XG4gICAgfVxuXG4gICAgSHRtbDUuVEVTVF9WSUQuY29uc3RydWN0b3IucHJvdG90eXBlLmNhblBsYXlUeXBlID0gZnVuY3Rpb24odHlwZSl7XG4gICAgICBpZiAodHlwZSAmJiBtcDRSRS50ZXN0KHR5cGUpKSB7XG4gICAgICAgIHJldHVybiAnbWF5YmUnO1xuICAgICAgfVxuICAgICAgcmV0dXJuIGNhblBsYXlUeXBlLmNhbGwodGhpcywgdHlwZSk7XG4gICAgfTtcbiAgfVxufTtcblxuSHRtbDUudW5wYXRjaENhblBsYXlUeXBlID0gZnVuY3Rpb24oKSB7XG4gIHZhciByID0gSHRtbDUuVEVTVF9WSUQuY29uc3RydWN0b3IucHJvdG90eXBlLmNhblBsYXlUeXBlO1xuICBIdG1sNS5URVNUX1ZJRC5jb25zdHJ1Y3Rvci5wcm90b3R5cGUuY2FuUGxheVR5cGUgPSBjYW5QbGF5VHlwZTtcbiAgY2FuUGxheVR5cGUgPSBudWxsO1xuICByZXR1cm4gcjtcbn07XG5cbi8vIGJ5IGRlZmF1bHQsIHBhdGNoIHRoZSB2aWRlbyBlbGVtZW50XG5IdG1sNS5wYXRjaENhblBsYXlUeXBlKCk7XG5cbkh0bWw1LmRpc3Bvc2VNZWRpYUVsZW1lbnQgPSBmdW5jdGlvbihlbCl7XG4gIGlmICghZWwpIHsgcmV0dXJuOyB9XG5cbiAgaWYgKGVsLnBhcmVudE5vZGUpIHtcbiAgICBlbC5wYXJlbnROb2RlLnJlbW92ZUNoaWxkKGVsKTtcbiAgfVxuXG4gIC8vIHJlbW92ZSBhbnkgY2hpbGQgdHJhY2sgb3Igc291cmNlIG5vZGVzIHRvIHByZXZlbnQgdGhlaXIgbG9hZGluZ1xuICB3aGlsZShlbC5oYXNDaGlsZE5vZGVzKCkpIHtcbiAgICBlbC5yZW1vdmVDaGlsZChlbC5maXJzdENoaWxkKTtcbiAgfVxuXG4gIC8vIHJlbW92ZSBhbnkgc3JjIHJlZmVyZW5jZS4gbm90IHNldHRpbmcgYHNyYz0nJ2AgYmVjYXVzZSB0aGF0IGNhdXNlcyBhIHdhcm5pbmdcbiAgLy8gaW4gZmlyZWZveFxuICBlbC5yZW1vdmVBdHRyaWJ1dGUoJ3NyYycpO1xuXG4gIC8vIGZvcmNlIHRoZSBtZWRpYSBlbGVtZW50IHRvIHVwZGF0ZSBpdHMgbG9hZGluZyBzdGF0ZSBieSBjYWxsaW5nIGxvYWQoKVxuICAvLyBob3dldmVyIElFIG9uIFdpbmRvd3MgN04gaGFzIGEgYnVnIHRoYXQgdGhyb3dzIGFuIGVycm9yIHNvIG5lZWQgYSB0cnkvY2F0Y2ggKCM3OTMpXG4gIGlmICh0eXBlb2YgZWwubG9hZCA9PT0gJ2Z1bmN0aW9uJykge1xuICAgIC8vIHdyYXBwaW5nIGluIGFuIGlpZmUgc28gaXQncyBub3QgZGVvcHRpbWl6ZWQgKCMxMDYwI2Rpc2N1c3Npb25fcjEwMzI0NDczKVxuICAgIChmdW5jdGlvbigpIHtcbiAgICAgIHRyeSB7XG4gICAgICAgIGVsLmxvYWQoKTtcbiAgICAgIH0gY2F0Y2ggKGUpIHtcbiAgICAgICAgLy8gbm90IHN1cHBvcnRlZFxuICAgICAgfVxuICAgIH0pKCk7XG4gIH1cbn07XG5cbkh0bWw1LnJlc2V0TWVkaWFFbGVtZW50ID0gZnVuY3Rpb24oZWwpe1xuICBpZiAoIWVsKSB7IHJldHVybjsgfVxuXG4gIGxldCBzb3VyY2VzID0gZWwucXVlcnlTZWxlY3RvckFsbCgnc291cmNlJyk7XG4gIGxldCBpID0gc291cmNlcy5sZW5ndGg7XG4gIHdoaWxlIChpLS0pIHtcbiAgICBlbC5yZW1vdmVDaGlsZChzb3VyY2VzW2ldKTtcbiAgfVxuXG4gIC8vIHJlbW92ZSBhbnkgc3JjIHJlZmVyZW5jZS5cbiAgLy8gbm90IHNldHRpbmcgYHNyYz0nJ2AgYmVjYXVzZSB0aGF0IHRocm93cyBhbiBlcnJvclxuICBlbC5yZW1vdmVBdHRyaWJ1dGUoJ3NyYycpO1xuXG4gIGlmICh0eXBlb2YgZWwubG9hZCA9PT0gJ2Z1bmN0aW9uJykge1xuICAgIC8vIHdyYXBwaW5nIGluIGFuIGlpZmUgc28gaXQncyBub3QgZGVvcHRpbWl6ZWQgKCMxMDYwI2Rpc2N1c3Npb25fcjEwMzI0NDczKVxuICAgIChmdW5jdGlvbigpIHtcbiAgICAgIHRyeSB7XG4gICAgICAgIGVsLmxvYWQoKTtcbiAgICAgIH0gY2F0Y2ggKGUpIHt9XG4gICAgfSkoKTtcbiAgfVxufTtcblxuQ29tcG9uZW50LnJlZ2lzdGVyQ29tcG9uZW50KCdIdG1sNScsIEh0bWw1KTtcblRlY2gucmVnaXN0ZXJUZWNoKCdIdG1sNScsIEh0bWw1KTtcbmV4cG9ydCBkZWZhdWx0IEh0bWw1O1xuIl19